function _n(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yt = { exports: {} }, z = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function Lo() {
  if (Hr) return z;
  Hr = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), f = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), v = Symbol.iterator;
  function E(c) {
    return c === null || typeof c != "object" ? null : (c = v && c[v] || c["@@iterator"], typeof c == "function" ? c : null);
  }
  var x = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, w = Object.assign, l = {};
  function I(c, g, O) {
    this.props = c, this.context = g, this.refs = l, this.updater = O || x;
  }
  I.prototype.isReactComponent = {}, I.prototype.setState = function(c, g) {
    if (typeof c != "object" && typeof c != "function" && c != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, c, g, "setState");
  }, I.prototype.forceUpdate = function(c) {
    this.updater.enqueueForceUpdate(this, c, "forceUpdate");
  };
  function Y() {
  }
  Y.prototype = I.prototype;
  function ne(c, g, O) {
    this.props = c, this.context = g, this.refs = l, this.updater = O || x;
  }
  var L = ne.prototype = new Y();
  L.constructor = ne, w(L, I.prototype), L.isPureReactComponent = !0;
  var $ = Array.isArray, S = Object.prototype.hasOwnProperty, K = { current: null }, le = { key: !0, ref: !0, __self: !0, __source: !0 };
  function ve(c, g, O) {
    var R, A = {}, D = null, N = null;
    if (g != null) for (R in g.ref !== void 0 && (N = g.ref), g.key !== void 0 && (D = "" + g.key), g) S.call(g, R) && !le.hasOwnProperty(R) && (A[R] = g[R]);
    var B = arguments.length - 2;
    if (B === 1) A.children = O;
    else if (1 < B) {
      for (var F = Array(B), W = 0; W < B; W++) F[W] = arguments[W + 2];
      A.children = F;
    }
    if (c && c.defaultProps) for (R in B = c.defaultProps, B) A[R] === void 0 && (A[R] = B[R]);
    return { $$typeof: e, type: c, key: D, ref: N, props: A, _owner: K.current };
  }
  function he(c, g) {
    return { $$typeof: e, type: c.type, key: g, ref: c.ref, props: c.props, _owner: c._owner };
  }
  function a(c) {
    return typeof c == "object" && c !== null && c.$$typeof === e;
  }
  function M(c) {
    var g = { "=": "=0", ":": "=2" };
    return "$" + c.replace(/[=:]/g, function(O) {
      return g[O];
    });
  }
  var q = /\/+/g;
  function X(c, g) {
    return typeof c == "object" && c !== null && c.key != null ? M("" + c.key) : g.toString(36);
  }
  function ye(c, g, O, R, A) {
    var D = typeof c;
    (D === "undefined" || D === "boolean") && (c = null);
    var N = !1;
    if (c === null) N = !0;
    else switch (D) {
      case "string":
      case "number":
        N = !0;
        break;
      case "object":
        switch (c.$$typeof) {
          case e:
          case r:
            N = !0;
        }
    }
    if (N) return N = c, A = A(N), c = R === "" ? "." + X(N, 0) : R, $(A) ? (O = "", c != null && (O = c.replace(q, "$&/") + "/"), ye(A, g, O, "", function(W) {
      return W;
    })) : A != null && (a(A) && (A = he(A, O + (!A.key || N && N.key === A.key ? "" : ("" + A.key).replace(q, "$&/") + "/") + c)), g.push(A)), 1;
    if (N = 0, R = R === "" ? "." : R + ":", $(c)) for (var B = 0; B < c.length; B++) {
      D = c[B];
      var F = R + X(D, B);
      N += ye(D, g, O, F, A);
    }
    else if (F = E(c), typeof F == "function") for (c = F.call(c), B = 0; !(D = c.next()).done; ) D = D.value, F = R + X(D, B++), N += ye(D, g, O, F, A);
    else if (D === "object") throw g = String(c), Error("Objects are not valid as a React child (found: " + (g === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : g) + "). If you meant to render a collection of children, use an array instead.");
    return N;
  }
  function de(c, g, O) {
    if (c == null) return c;
    var R = [], A = 0;
    return ye(c, R, "", "", function(D) {
      return g.call(O, D, A++);
    }), R;
  }
  function ge(c) {
    if (c._status === -1) {
      var g = c._result;
      g = g(), g.then(function(O) {
        (c._status === 0 || c._status === -1) && (c._status = 1, c._result = O);
      }, function(O) {
        (c._status === 0 || c._status === -1) && (c._status = 2, c._result = O);
      }), c._status === -1 && (c._status = 0, c._result = g);
    }
    if (c._status === 1) return c._result.default;
    throw c._result;
  }
  var j = { current: null }, we = { transition: null }, Ae = { ReactCurrentDispatcher: j, ReactCurrentBatchConfig: we, ReactCurrentOwner: K };
  function C() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return z.Children = { map: de, forEach: function(c, g, O) {
    de(c, function() {
      g.apply(this, arguments);
    }, O);
  }, count: function(c) {
    var g = 0;
    return de(c, function() {
      g++;
    }), g;
  }, toArray: function(c) {
    return de(c, function(g) {
      return g;
    }) || [];
  }, only: function(c) {
    if (!a(c)) throw Error("React.Children.only expected to receive a single React element child.");
    return c;
  } }, z.Component = I, z.Fragment = n, z.Profiler = i, z.PureComponent = ne, z.StrictMode = o, z.Suspense = y, z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ae, z.act = C, z.cloneElement = function(c, g, O) {
    if (c == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + c + ".");
    var R = w({}, c.props), A = c.key, D = c.ref, N = c._owner;
    if (g != null) {
      if (g.ref !== void 0 && (D = g.ref, N = K.current), g.key !== void 0 && (A = "" + g.key), c.type && c.type.defaultProps) var B = c.type.defaultProps;
      for (F in g) S.call(g, F) && !le.hasOwnProperty(F) && (R[F] = g[F] === void 0 && B !== void 0 ? B[F] : g[F]);
    }
    var F = arguments.length - 2;
    if (F === 1) R.children = O;
    else if (1 < F) {
      B = Array(F);
      for (var W = 0; W < F; W++) B[W] = arguments[W + 2];
      R.children = B;
    }
    return { $$typeof: e, type: c.type, key: A, ref: D, props: R, _owner: N };
  }, z.createContext = function(c) {
    return c = { $$typeof: f, _currentValue: c, _currentValue2: c, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, c.Provider = { $$typeof: u, _context: c }, c.Consumer = c;
  }, z.createElement = ve, z.createFactory = function(c) {
    var g = ve.bind(null, c);
    return g.type = c, g;
  }, z.createRef = function() {
    return { current: null };
  }, z.forwardRef = function(c) {
    return { $$typeof: d, render: c };
  }, z.isValidElement = a, z.lazy = function(c) {
    return { $$typeof: _, _payload: { _status: -1, _result: c }, _init: ge };
  }, z.memo = function(c, g) {
    return { $$typeof: b, type: c, compare: g === void 0 ? null : g };
  }, z.startTransition = function(c) {
    var g = we.transition;
    we.transition = {};
    try {
      c();
    } finally {
      we.transition = g;
    }
  }, z.unstable_act = C, z.useCallback = function(c, g) {
    return j.current.useCallback(c, g);
  }, z.useContext = function(c) {
    return j.current.useContext(c);
  }, z.useDebugValue = function() {
  }, z.useDeferredValue = function(c) {
    return j.current.useDeferredValue(c);
  }, z.useEffect = function(c, g) {
    return j.current.useEffect(c, g);
  }, z.useId = function() {
    return j.current.useId();
  }, z.useImperativeHandle = function(c, g, O) {
    return j.current.useImperativeHandle(c, g, O);
  }, z.useInsertionEffect = function(c, g) {
    return j.current.useInsertionEffect(c, g);
  }, z.useLayoutEffect = function(c, g) {
    return j.current.useLayoutEffect(c, g);
  }, z.useMemo = function(c, g) {
    return j.current.useMemo(c, g);
  }, z.useReducer = function(c, g, O) {
    return j.current.useReducer(c, g, O);
  }, z.useRef = function(c) {
    return j.current.useRef(c);
  }, z.useState = function(c) {
    return j.current.useState(c);
  }, z.useSyncExternalStore = function(c, g, O) {
    return j.current.useSyncExternalStore(c, g, O);
  }, z.useTransition = function() {
    return j.current.useTransition();
  }, z.version = "18.3.1", z;
}
var Je = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Je.exports;
var Zr;
function Vo() {
  return Zr || (Zr = 1, function(e, r) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = "18.3.1", o = Symbol.for("react.element"), i = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), b = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), I = Symbol.iterator, Y = "@@iterator";
      function ne(t) {
        if (t === null || typeof t != "object")
          return null;
        var s = I && t[I] || t[Y];
        return typeof s == "function" ? s : null;
      }
      var L = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, $ = {
        transition: null
      }, S = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, K = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, le = {}, ve = null;
      function he(t) {
        ve = t;
      }
      le.setExtraStackFrame = function(t) {
        ve = t;
      }, le.getCurrentStack = null, le.getStackAddendum = function() {
        var t = "";
        ve && (t += ve);
        var s = le.getCurrentStack;
        return s && (t += s() || ""), t;
      };
      var a = !1, M = !1, q = !1, X = !1, ye = !1, de = {
        ReactCurrentDispatcher: L,
        ReactCurrentBatchConfig: $,
        ReactCurrentOwner: K
      };
      de.ReactDebugCurrentFrame = le, de.ReactCurrentActQueue = S;
      function ge(t) {
        {
          for (var s = arguments.length, p = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
            p[m - 1] = arguments[m];
          we("warn", t, p);
        }
      }
      function j(t) {
        {
          for (var s = arguments.length, p = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
            p[m - 1] = arguments[m];
          we("error", t, p);
        }
      }
      function we(t, s, p) {
        {
          var m = de.ReactDebugCurrentFrame, T = m.getStackAddendum();
          T !== "" && (s += "%s", p = p.concat([T]));
          var V = p.map(function(P) {
            return String(P);
          });
          V.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, V);
        }
      }
      var Ae = {};
      function C(t, s) {
        {
          var p = t.constructor, m = p && (p.displayName || p.name) || "ReactClass", T = m + "." + s;
          if (Ae[T])
            return;
          j("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", s, m), Ae[T] = !0;
        }
      }
      var c = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(t) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(t, s, p) {
          C(t, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(t, s, p, m) {
          C(t, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(t, s, p, m) {
          C(t, "setState");
        }
      }, g = Object.assign, O = {};
      Object.freeze(O);
      function R(t, s, p) {
        this.props = t, this.context = s, this.refs = O, this.updater = p || c;
      }
      R.prototype.isReactComponent = {}, R.prototype.setState = function(t, s) {
        if (typeof t != "object" && typeof t != "function" && t != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, t, s, "setState");
      }, R.prototype.forceUpdate = function(t) {
        this.updater.enqueueForceUpdate(this, t, "forceUpdate");
      };
      {
        var A = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, D = function(t, s) {
          Object.defineProperty(R.prototype, t, {
            get: function() {
              ge("%s(...) is deprecated in plain JavaScript React classes. %s", s[0], s[1]);
            }
          });
        };
        for (var N in A)
          A.hasOwnProperty(N) && D(N, A[N]);
      }
      function B() {
      }
      B.prototype = R.prototype;
      function F(t, s, p) {
        this.props = t, this.context = s, this.refs = O, this.updater = p || c;
      }
      var W = F.prototype = new B();
      W.constructor = F, g(W, R.prototype), W.isPureReactComponent = !0;
      function Ee() {
        var t = {
          current: null
        };
        return Object.seal(t), t;
      }
      var k = Array.isArray;
      function Se(t) {
        return k(t);
      }
      function je(t) {
        {
          var s = typeof Symbol == "function" && Symbol.toStringTag, p = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
          return p;
        }
      }
      function at(t) {
        try {
          return dr(t), !1;
        } catch {
          return !0;
        }
      }
      function dr(t) {
        return "" + t;
      }
      function st(t) {
        if (at(t))
          return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", je(t)), dr(t);
      }
      function jn(t, s, p) {
        var m = t.displayName;
        if (m)
          return m;
        var T = s.displayName || s.name || "";
        return T !== "" ? p + "(" + T + ")" : p;
      }
      function pr(t) {
        return t.displayName || "Context";
      }
      function Pe(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case u:
            return "Fragment";
          case i:
            return "Portal";
          case d:
            return "Profiler";
          case f:
            return "StrictMode";
          case v:
            return "Suspense";
          case E:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case b:
              var s = t;
              return pr(s) + ".Consumer";
            case y:
              var p = t;
              return pr(p._context) + ".Provider";
            case _:
              return jn(t, t.render, "ForwardRef");
            case x:
              var m = t.displayName || null;
              return m !== null ? m : Pe(t.type) || "Memo";
            case w: {
              var T = t, V = T._payload, P = T._init;
              try {
                return Pe(P(V));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Ke = Object.prototype.hasOwnProperty, mr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, hr, gr, Nt;
      Nt = {};
      function yr(t) {
        if (Ke.call(t, "ref")) {
          var s = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (s && s.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function vr(t) {
        if (Ke.call(t, "key")) {
          var s = Object.getOwnPropertyDescriptor(t, "key").get;
          if (s && s.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function Bn(t, s) {
        var p = function() {
          hr || (hr = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
      function Fn(t, s) {
        var p = function() {
          gr || (gr = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
      function Ln(t) {
        if (typeof t.ref == "string" && K.current && t.__self && K.current.stateNode !== t.__self) {
          var s = Pe(K.current.type);
          Nt[s] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', s, t.ref), Nt[s] = !0);
        }
      }
      var jt = function(t, s, p, m, T, V, P) {
        var U = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: o,
          // Built-in properties that belong on the element
          type: t,
          key: s,
          ref: p,
          props: P,
          // Record the component responsible for creating this element.
          _owner: V
        };
        return U._store = {}, Object.defineProperty(U._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(U, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: m
        }), Object.defineProperty(U, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: T
        }), Object.freeze && (Object.freeze(U.props), Object.freeze(U)), U;
      };
      function Vn(t, s, p) {
        var m, T = {}, V = null, P = null, U = null, G = null;
        if (s != null) {
          yr(s) && (P = s.ref, Ln(s)), vr(s) && (st(s.key), V = "" + s.key), U = s.__self === void 0 ? null : s.__self, G = s.__source === void 0 ? null : s.__source;
          for (m in s)
            Ke.call(s, m) && !mr.hasOwnProperty(m) && (T[m] = s[m]);
        }
        var ee = arguments.length - 2;
        if (ee === 1)
          T.children = p;
        else if (ee > 1) {
          for (var oe = Array(ee), ie = 0; ie < ee; ie++)
            oe[ie] = arguments[ie + 2];
          Object.freeze && Object.freeze(oe), T.children = oe;
        }
        if (t && t.defaultProps) {
          var se = t.defaultProps;
          for (m in se)
            T[m] === void 0 && (T[m] = se[m]);
        }
        if (V || P) {
          var pe = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          V && Bn(T, pe), P && Fn(T, pe);
        }
        return jt(t, V, P, U, G, K.current, T);
      }
      function Wn(t, s) {
        var p = jt(t.type, s, t.ref, t._self, t._source, t._owner, t.props);
        return p;
      }
      function Un(t, s, p) {
        if (t == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + t + ".");
        var m, T = g({}, t.props), V = t.key, P = t.ref, U = t._self, G = t._source, ee = t._owner;
        if (s != null) {
          yr(s) && (P = s.ref, ee = K.current), vr(s) && (st(s.key), V = "" + s.key);
          var oe;
          t.type && t.type.defaultProps && (oe = t.type.defaultProps);
          for (m in s)
            Ke.call(s, m) && !mr.hasOwnProperty(m) && (s[m] === void 0 && oe !== void 0 ? T[m] = oe[m] : T[m] = s[m]);
        }
        var ie = arguments.length - 2;
        if (ie === 1)
          T.children = p;
        else if (ie > 1) {
          for (var se = Array(ie), pe = 0; pe < ie; pe++)
            se[pe] = arguments[pe + 2];
          T.children = se;
        }
        return jt(t.type, V, P, U, G, ee, T);
      }
      function Be(t) {
        return typeof t == "object" && t !== null && t.$$typeof === o;
      }
      var br = ".", Yn = ":";
      function zn(t) {
        var s = /[=:]/g, p = {
          "=": "=0",
          ":": "=2"
        }, m = t.replace(s, function(T) {
          return p[T];
        });
        return "$" + m;
      }
      var Er = !1, qn = /\/+/g;
      function Sr(t) {
        return t.replace(qn, "$&/");
      }
      function Bt(t, s) {
        return typeof t == "object" && t !== null && t.key != null ? (st(t.key), zn("" + t.key)) : s.toString(36);
      }
      function ut(t, s, p, m, T) {
        var V = typeof t;
        (V === "undefined" || V === "boolean") && (t = null);
        var P = !1;
        if (t === null)
          P = !0;
        else
          switch (V) {
            case "string":
            case "number":
              P = !0;
              break;
            case "object":
              switch (t.$$typeof) {
                case o:
                case i:
                  P = !0;
              }
          }
        if (P) {
          var U = t, G = T(U), ee = m === "" ? br + Bt(U, 0) : m;
          if (Se(G)) {
            var oe = "";
            ee != null && (oe = Sr(ee) + "/"), ut(G, s, oe, "", function(Fo) {
              return Fo;
            });
          } else G != null && (Be(G) && (G.key && (!U || U.key !== G.key) && st(G.key), G = Wn(
            G,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            p + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (G.key && (!U || U.key !== G.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Sr("" + G.key) + "/"
            ) : "") + ee
          )), s.push(G));
          return 1;
        }
        var ie, se, pe = 0, be = m === "" ? br : m + Yn;
        if (Se(t))
          for (var gt = 0; gt < t.length; gt++)
            ie = t[gt], se = be + Bt(ie, gt), pe += ut(ie, s, p, se, T);
        else {
          var Gt = ne(t);
          if (typeof Gt == "function") {
            var qr = t;
            Gt === qr.entries && (Er || ge("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Er = !0);
            for (var jo = Gt.call(qr), Gr, Bo = 0; !(Gr = jo.next()).done; )
              ie = Gr.value, se = be + Bt(ie, Bo++), pe += ut(ie, s, p, se, T);
          } else if (V === "object") {
            var Kr = String(t);
            throw new Error("Objects are not valid as a React child (found: " + (Kr === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : Kr) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return pe;
      }
      function ct(t, s, p) {
        if (t == null)
          return t;
        var m = [], T = 0;
        return ut(t, m, "", "", function(V) {
          return s.call(p, V, T++);
        }), m;
      }
      function Gn(t) {
        var s = 0;
        return ct(t, function() {
          s++;
        }), s;
      }
      function Kn(t, s, p) {
        ct(t, function() {
          s.apply(this, arguments);
        }, p);
      }
      function Hn(t) {
        return ct(t, function(s) {
          return s;
        }) || [];
      }
      function Zn(t) {
        if (!Be(t))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return t;
      }
      function Xn(t) {
        var s = {
          $$typeof: b,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: t,
          _currentValue2: t,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        s.Provider = {
          $$typeof: y,
          _context: s
        };
        var p = !1, m = !1, T = !1;
        {
          var V = {
            $$typeof: b,
            _context: s
          };
          Object.defineProperties(V, {
            Provider: {
              get: function() {
                return m || (m = !0, j("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), s.Provider;
              },
              set: function(P) {
                s.Provider = P;
              }
            },
            _currentValue: {
              get: function() {
                return s._currentValue;
              },
              set: function(P) {
                s._currentValue = P;
              }
            },
            _currentValue2: {
              get: function() {
                return s._currentValue2;
              },
              set: function(P) {
                s._currentValue2 = P;
              }
            },
            _threadCount: {
              get: function() {
                return s._threadCount;
              },
              set: function(P) {
                s._threadCount = P;
              }
            },
            Consumer: {
              get: function() {
                return p || (p = !0, j("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), s.Consumer;
              }
            },
            displayName: {
              get: function() {
                return s.displayName;
              },
              set: function(P) {
                T || (ge("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", P), T = !0);
              }
            }
          }), s.Consumer = V;
        }
        return s._currentRenderer = null, s._currentRenderer2 = null, s;
      }
      var He = -1, Ft = 0, Cr = 1, Qn = 2;
      function Jn(t) {
        if (t._status === He) {
          var s = t._result, p = s();
          if (p.then(function(V) {
            if (t._status === Ft || t._status === He) {
              var P = t;
              P._status = Cr, P._result = V;
            }
          }, function(V) {
            if (t._status === Ft || t._status === He) {
              var P = t;
              P._status = Qn, P._result = V;
            }
          }), t._status === He) {
            var m = t;
            m._status = Ft, m._result = p;
          }
        }
        if (t._status === Cr) {
          var T = t._result;
          return T === void 0 && j(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, T), "default" in T || j(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, T), T.default;
        } else
          throw t._result;
      }
      function eo(t) {
        var s = {
          // We use these fields to store the result.
          _status: He,
          _result: t
        }, p = {
          $$typeof: w,
          _payload: s,
          _init: Jn
        };
        {
          var m, T;
          Object.defineProperties(p, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return m;
              },
              set: function(V) {
                j("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), m = V, Object.defineProperty(p, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return T;
              },
              set: function(V) {
                j("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), T = V, Object.defineProperty(p, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return p;
      }
      function to(t) {
        t != null && t.$$typeof === x ? j("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof t != "function" ? j("forwardRef requires a render function but was given %s.", t === null ? "null" : typeof t) : t.length !== 0 && t.length !== 2 && j("forwardRef render functions accept exactly two parameters: props and ref. %s", t.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), t != null && (t.defaultProps != null || t.propTypes != null) && j("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var s = {
          $$typeof: _,
          render: t
        };
        {
          var p;
          Object.defineProperty(s, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return p;
            },
            set: function(m) {
              p = m, !t.name && !t.displayName && (t.displayName = m);
            }
          });
        }
        return s;
      }
      var _r;
      _r = Symbol.for("react.module.reference");
      function Tr(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === u || t === d || ye || t === f || t === v || t === E || X || t === l || a || M || q || typeof t == "object" && t !== null && (t.$$typeof === w || t.$$typeof === x || t.$$typeof === y || t.$$typeof === b || t.$$typeof === _ || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        t.$$typeof === _r || t.getModuleId !== void 0));
      }
      function ro(t, s) {
        Tr(t) || j("memo: The first argument must be a component. Instead received: %s", t === null ? "null" : typeof t);
        var p = {
          $$typeof: x,
          type: t,
          compare: s === void 0 ? null : s
        };
        {
          var m;
          Object.defineProperty(p, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return m;
            },
            set: function(T) {
              m = T, !t.name && !t.displayName && (t.displayName = T);
            }
          });
        }
        return p;
      }
      function Ce() {
        var t = L.current;
        return t === null && j(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), t;
      }
      function no(t) {
        var s = Ce();
        if (t._context !== void 0) {
          var p = t._context;
          p.Consumer === t ? j("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : p.Provider === t && j("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return s.useContext(t);
      }
      function oo(t) {
        var s = Ce();
        return s.useState(t);
      }
      function io(t, s, p) {
        var m = Ce();
        return m.useReducer(t, s, p);
      }
      function ao(t) {
        var s = Ce();
        return s.useRef(t);
      }
      function so(t, s) {
        var p = Ce();
        return p.useEffect(t, s);
      }
      function uo(t, s) {
        var p = Ce();
        return p.useInsertionEffect(t, s);
      }
      function co(t, s) {
        var p = Ce();
        return p.useLayoutEffect(t, s);
      }
      function lo(t, s) {
        var p = Ce();
        return p.useCallback(t, s);
      }
      function fo(t, s) {
        var p = Ce();
        return p.useMemo(t, s);
      }
      function po(t, s, p) {
        var m = Ce();
        return m.useImperativeHandle(t, s, p);
      }
      function mo(t, s) {
        {
          var p = Ce();
          return p.useDebugValue(t, s);
        }
      }
      function ho() {
        var t = Ce();
        return t.useTransition();
      }
      function go(t) {
        var s = Ce();
        return s.useDeferredValue(t);
      }
      function yo() {
        var t = Ce();
        return t.useId();
      }
      function vo(t, s, p) {
        var m = Ce();
        return m.useSyncExternalStore(t, s, p);
      }
      var Ze = 0, wr, Rr, xr, Or, kr, $r, Ar;
      function Pr() {
      }
      Pr.__reactDisabledLog = !0;
      function bo() {
        {
          if (Ze === 0) {
            wr = console.log, Rr = console.info, xr = console.warn, Or = console.error, kr = console.group, $r = console.groupCollapsed, Ar = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: Pr,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          Ze++;
        }
      }
      function Eo() {
        {
          if (Ze--, Ze === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: g({}, t, {
                value: wr
              }),
              info: g({}, t, {
                value: Rr
              }),
              warn: g({}, t, {
                value: xr
              }),
              error: g({}, t, {
                value: Or
              }),
              group: g({}, t, {
                value: kr
              }),
              groupCollapsed: g({}, t, {
                value: $r
              }),
              groupEnd: g({}, t, {
                value: Ar
              })
            });
          }
          Ze < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Lt = de.ReactCurrentDispatcher, Vt;
      function lt(t, s, p) {
        {
          if (Vt === void 0)
            try {
              throw Error();
            } catch (T) {
              var m = T.stack.trim().match(/\n( *(at )?)/);
              Vt = m && m[1] || "";
            }
          return `
` + Vt + t;
        }
      }
      var Wt = !1, ft;
      {
        var So = typeof WeakMap == "function" ? WeakMap : Map;
        ft = new So();
      }
      function Ir(t, s) {
        if (!t || Wt)
          return "";
        {
          var p = ft.get(t);
          if (p !== void 0)
            return p;
        }
        var m;
        Wt = !0;
        var T = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var V;
        V = Lt.current, Lt.current = null, bo();
        try {
          if (s) {
            var P = function() {
              throw Error();
            };
            if (Object.defineProperty(P.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(P, []);
              } catch (be) {
                m = be;
              }
              Reflect.construct(t, [], P);
            } else {
              try {
                P.call();
              } catch (be) {
                m = be;
              }
              t.call(P.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (be) {
              m = be;
            }
            t();
          }
        } catch (be) {
          if (be && m && typeof be.stack == "string") {
            for (var U = be.stack.split(`
`), G = m.stack.split(`
`), ee = U.length - 1, oe = G.length - 1; ee >= 1 && oe >= 0 && U[ee] !== G[oe]; )
              oe--;
            for (; ee >= 1 && oe >= 0; ee--, oe--)
              if (U[ee] !== G[oe]) {
                if (ee !== 1 || oe !== 1)
                  do
                    if (ee--, oe--, oe < 0 || U[ee] !== G[oe]) {
                      var ie = `
` + U[ee].replace(" at new ", " at ");
                      return t.displayName && ie.includes("<anonymous>") && (ie = ie.replace("<anonymous>", t.displayName)), typeof t == "function" && ft.set(t, ie), ie;
                    }
                  while (ee >= 1 && oe >= 0);
                break;
              }
          }
        } finally {
          Wt = !1, Lt.current = V, Eo(), Error.prepareStackTrace = T;
        }
        var se = t ? t.displayName || t.name : "", pe = se ? lt(se) : "";
        return typeof t == "function" && ft.set(t, pe), pe;
      }
      function Co(t, s, p) {
        return Ir(t, !1);
      }
      function _o(t) {
        var s = t.prototype;
        return !!(s && s.isReactComponent);
      }
      function dt(t, s, p) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return Ir(t, _o(t));
        if (typeof t == "string")
          return lt(t);
        switch (t) {
          case v:
            return lt("Suspense");
          case E:
            return lt("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case _:
              return Co(t.render);
            case x:
              return dt(t.type, s, p);
            case w: {
              var m = t, T = m._payload, V = m._init;
              try {
                return dt(V(T), s, p);
              } catch {
              }
            }
          }
        return "";
      }
      var Mr = {}, Dr = de.ReactDebugCurrentFrame;
      function pt(t) {
        if (t) {
          var s = t._owner, p = dt(t.type, t._source, s ? s.type : null);
          Dr.setExtraStackFrame(p);
        } else
          Dr.setExtraStackFrame(null);
      }
      function To(t, s, p, m, T) {
        {
          var V = Function.call.bind(Ke);
          for (var P in t)
            if (V(t, P)) {
              var U = void 0;
              try {
                if (typeof t[P] != "function") {
                  var G = Error((m || "React class") + ": " + p + " type `" + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[P] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw G.name = "Invariant Violation", G;
                }
                U = t[P](s, P, m, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ee) {
                U = ee;
              }
              U && !(U instanceof Error) && (pt(T), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", p, P, typeof U), pt(null)), U instanceof Error && !(U.message in Mr) && (Mr[U.message] = !0, pt(T), j("Failed %s type: %s", p, U.message), pt(null));
            }
        }
      }
      function Fe(t) {
        if (t) {
          var s = t._owner, p = dt(t.type, t._source, s ? s.type : null);
          he(p);
        } else
          he(null);
      }
      var Ut;
      Ut = !1;
      function Nr() {
        if (K.current) {
          var t = Pe(K.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
      function wo(t) {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), p = t.lineNumber;
          return `

Check your code at ` + s + ":" + p + ".";
        }
        return "";
      }
      function Ro(t) {
        return t != null ? wo(t.__source) : "";
      }
      var jr = {};
      function xo(t) {
        var s = Nr();
        if (!s) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (s = `

Check the top-level render call using <` + p + ">.");
        }
        return s;
      }
      function Br(t, s) {
        if (!(!t._store || t._store.validated || t.key != null)) {
          t._store.validated = !0;
          var p = xo(s);
          if (!jr[p]) {
            jr[p] = !0;
            var m = "";
            t && t._owner && t._owner !== K.current && (m = " It was passed a child from " + Pe(t._owner.type) + "."), Fe(t), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, m), Fe(null);
          }
        }
      }
      function Fr(t, s) {
        if (typeof t == "object") {
          if (Se(t))
            for (var p = 0; p < t.length; p++) {
              var m = t[p];
              Be(m) && Br(m, s);
            }
          else if (Be(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var T = ne(t);
            if (typeof T == "function" && T !== t.entries)
              for (var V = T.call(t), P; !(P = V.next()).done; )
                Be(P.value) && Br(P.value, s);
          }
        }
      }
      function Lr(t) {
        {
          var s = t.type;
          if (s == null || typeof s == "string")
            return;
          var p;
          if (typeof s == "function")
            p = s.propTypes;
          else if (typeof s == "object" && (s.$$typeof === _ || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          s.$$typeof === x))
            p = s.propTypes;
          else
            return;
          if (p) {
            var m = Pe(s);
            To(p, t.props, "prop", m, t);
          } else if (s.PropTypes !== void 0 && !Ut) {
            Ut = !0;
            var T = Pe(s);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
          }
          typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Oo(t) {
        {
          for (var s = Object.keys(t.props), p = 0; p < s.length; p++) {
            var m = s[p];
            if (m !== "children" && m !== "key") {
              Fe(t), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), Fe(null);
              break;
            }
          }
          t.ref !== null && (Fe(t), j("Invalid attribute `ref` supplied to `React.Fragment`."), Fe(null));
        }
      }
      function Vr(t, s, p) {
        var m = Tr(t);
        if (!m) {
          var T = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = Ro(s);
          V ? T += V : T += Nr();
          var P;
          t === null ? P = "null" : Se(t) ? P = "array" : t !== void 0 && t.$$typeof === o ? (P = "<" + (Pe(t.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : P = typeof t, j("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", P, T);
        }
        var U = Vn.apply(this, arguments);
        if (U == null)
          return U;
        if (m)
          for (var G = 2; G < arguments.length; G++)
            Fr(arguments[G], t);
        return t === u ? Oo(U) : Lr(U), U;
      }
      var Wr = !1;
      function ko(t) {
        var s = Vr.bind(null, t);
        return s.type = t, Wr || (Wr = !0, ge("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(s, "type", {
          enumerable: !1,
          get: function() {
            return ge("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: t
            }), t;
          }
        }), s;
      }
      function $o(t, s, p) {
        for (var m = Un.apply(this, arguments), T = 2; T < arguments.length; T++)
          Fr(arguments[T], m.type);
        return Lr(m), m;
      }
      function Ao(t, s) {
        var p = $.transition;
        $.transition = {};
        var m = $.transition;
        $.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          t();
        } finally {
          if ($.transition = p, p === null && m._updatedFibers) {
            var T = m._updatedFibers.size;
            T > 10 && ge("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), m._updatedFibers.clear();
          }
        }
      }
      var Ur = !1, mt = null;
      function Po(t) {
        if (mt === null)
          try {
            var s = ("require" + Math.random()).slice(0, 7), p = e && e[s];
            mt = p.call(e, "timers").setImmediate;
          } catch {
            mt = function(T) {
              Ur === !1 && (Ur = !0, typeof MessageChannel > "u" && j("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var V = new MessageChannel();
              V.port1.onmessage = T, V.port2.postMessage(void 0);
            };
          }
        return mt(t);
      }
      var Le = 0, Yr = !1;
      function zr(t) {
        {
          var s = Le;
          Le++, S.current === null && (S.current = []);
          var p = S.isBatchingLegacy, m;
          try {
            if (S.isBatchingLegacy = !0, m = t(), !p && S.didScheduleLegacyUpdate) {
              var T = S.current;
              T !== null && (S.didScheduleLegacyUpdate = !1, qt(T));
            }
          } catch (se) {
            throw ht(s), se;
          } finally {
            S.isBatchingLegacy = p;
          }
          if (m !== null && typeof m == "object" && typeof m.then == "function") {
            var V = m, P = !1, U = {
              then: function(se, pe) {
                P = !0, V.then(function(be) {
                  ht(s), Le === 0 ? Yt(be, se, pe) : se(be);
                }, function(be) {
                  ht(s), pe(be);
                });
              }
            };
            return !Yr && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              P || (Yr = !0, j("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), U;
          } else {
            var G = m;
            if (ht(s), Le === 0) {
              var ee = S.current;
              ee !== null && (qt(ee), S.current = null);
              var oe = {
                then: function(se, pe) {
                  S.current === null ? (S.current = [], Yt(G, se, pe)) : se(G);
                }
              };
              return oe;
            } else {
              var ie = {
                then: function(se, pe) {
                  se(G);
                }
              };
              return ie;
            }
          }
        }
      }
      function ht(t) {
        t !== Le - 1 && j("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Le = t;
      }
      function Yt(t, s, p) {
        {
          var m = S.current;
          if (m !== null)
            try {
              qt(m), Po(function() {
                m.length === 0 ? (S.current = null, s(t)) : Yt(t, s, p);
              });
            } catch (T) {
              p(T);
            }
          else
            s(t);
        }
      }
      var zt = !1;
      function qt(t) {
        if (!zt) {
          zt = !0;
          var s = 0;
          try {
            for (; s < t.length; s++) {
              var p = t[s];
              do
                p = p(!0);
              while (p !== null);
            }
            t.length = 0;
          } catch (m) {
            throw t = t.slice(s + 1), m;
          } finally {
            zt = !1;
          }
        }
      }
      var Io = Vr, Mo = $o, Do = ko, No = {
        map: ct,
        forEach: Kn,
        count: Gn,
        toArray: Hn,
        only: Zn
      };
      r.Children = No, r.Component = R, r.Fragment = u, r.Profiler = d, r.PureComponent = F, r.StrictMode = f, r.Suspense = v, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = de, r.act = zr, r.cloneElement = Mo, r.createContext = Xn, r.createElement = Io, r.createFactory = Do, r.createRef = Ee, r.forwardRef = to, r.isValidElement = Be, r.lazy = eo, r.memo = ro, r.startTransition = Ao, r.unstable_act = zr, r.useCallback = lo, r.useContext = no, r.useDebugValue = mo, r.useDeferredValue = go, r.useEffect = so, r.useId = yo, r.useImperativeHandle = po, r.useInsertionEffect = uo, r.useLayoutEffect = co, r.useMemo = fo, r.useReducer = io, r.useRef = ao, r.useState = oo, r.useSyncExternalStore = vo, r.useTransition = ho, r.version = n, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Je, Je.exports)), Je.exports;
}
var Xr;
function Wo() {
  return Xr || (Xr = 1, process.env.NODE_ENV === "production" ? yt.exports = Lo() : yt.exports = Vo()), yt.exports;
}
var or = Wo();
const me = /* @__PURE__ */ _n(or), za = (e) => /* @__PURE__ */ me.createElement(
  "svg",
  {
    id: "b",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 1201 333",
    ...e
  },
  /* @__PURE__ */ me.createElement("g", { id: "c" }, /* @__PURE__ */ me.createElement("g", null, /* @__PURE__ */ me.createElement("path", { d: "M166.02,265.38c1.64,.61,3.23,1.49,4.92,1.79,8.72,1.58,17.16,3.97,24.77,8.65,18.14,11.15,25.63,27.81,25.38,48.8-.78-.1-1.35,0-1.6-.22-8.03-7.27-17.89-9.31-28.2-9.22-16.39,.15-32.3,3.52-47.95,8.19-8.9,2.65-17.78,5.36-26.7,7.95-2.52,.73-5.14,1.13-7.71,1.68h-20.98c-3.22-.73-6.43-1.46-9.65-2.19-8.35-1.88-16.13-5.17-23.59-9.28-.54-.3-1.01-.7-1.23-1.71,.73,.17,1.51,.23,2.18,.53,24.42,10.9,48.77,9.63,73.19-.11,10.33-4.12,20.67-8.38,31.33-11.49,7.25-2.11,15.04-3.11,22.61-3.23,14.07-.23,27.05,3.24,37.24,14.66-.32-1.98-.6-3.98-.97-5.95-4.38-22.84-19.37-37.52-42.37-42.01-17.52-3.42-34.81-1.78-52.03,1.72-13.88,2.82-27.77,5.53-42.02,5.16-18.59-.48-36.35-4.22-52.3-14.28-12.34-7.78-21.65-18.15-25.99-32.33-5.14-16.78-1.38-32.16,8.03-46.46,4.61-7,10.4-12.97,17.02-18.1,13.36-10.35,25.57-21.78,34.83-36.05,.24-.38,.72-.6,1.91-1.57-1,2.33-1.55,3.82-2.26,5.23-6.9,13.7-16.83,24.99-27.85,35.52-5.26,5.03-10.47,10.32-14.66,16.22-16.3,22.96-12.52,49.65,9.32,67.45,4.18,3.41,8.96,6.08,14.03,8.79-6.68-14.85-7.14-28.27,7.11-38.99-.46,.89-.85,1.83-1.38,2.67-4.25,6.74-5.08,14.03-2.91,21.54,2.44,8.46,7.58,15.07,15.13,19.7,5.33,3.27,11.42,3.36,17.37,3.76,14.22,.98,28.22-.82,42.17-3.44,12.47-2.34,25.05-3.43,37.76-2.69,.44,.03,.88-.12,1.96-.29-.92-.83-1.43-1.39-2.03-1.82-16.36-11.51-29.37-25.94-38.23-43.93-8.74-17.76-20.43-33.41-33.91-47.8-.33-.36-.56-.81-.55-1.7,.84,.49,1.79,.85,2.51,1.48,13.76,12.18,26.05,25.55,35.75,41.32,5.02,8.17,11.26,15.62,17.14,23.24,6.9,8.95,14.01,17.74,21.06,26.57,.71,.88,1.67,1.57,2.51,2.34l-.12-.12Z" }), /* @__PURE__ */ me.createElement("path", { d: "M1201,122.63c-2.23,.44-4.46,1.24-6.7,1.26-14.49,.11-28.97,.06-43.46,.06-1.82,0-3.64,0-5.37,0-1.18,3.71-1.46,31.37-.35,37.96,1.65,0,3.43,0,5.2,0,12.66,0,25.31-.04,37.97,.02,4.2,.02,5.5,1.26,5.51,4.7,.01,3.42-1.42,4.81-5.4,4.84-9.82,.06-19.65,.02-29.47,.02-4.62,0-9.24,0-14.14,0v40.57c1.75,.09,3.34,.24,4.94,.24,14.99,.02,29.97,.02,44.96,0,2.37,0,4.69-.08,6.33,2.06v5.98c-2.24,.4-4.48,1.13-6.72,1.14-17.79,.1-35.58,.07-53.37,.05-5.87,0-6.58-.71-6.59-6.61-.02-31.19-.02-62.38,0-93.57,0-6.02,.68-6.72,6.46-6.73,17.96-.02,35.92,.01,53.87-.03,2.4,0,4.65,.09,6.35,2.07v5.98Z" }), /* @__PURE__ */ me.createElement("path", { d: "M1093.73,180.2c-5.48,0-10.42,0-15.37,0-2.83,0-5.67,.14-8.48-.09-3.06-.26-3.87-1.59-3.72-5.26,.14-3.28,.94-4.35,4.07-4.38,9.65-.1,19.31-.1,28.96,0,3.31,.03,4.47,1.14,4.51,4.59,.11,10.96,.06,21.92,.01,32.88-.01,2.51-1.23,4.44-3.43,5.69-19.56,11.13-52.46,16.47-75.73-7.11-16.62-16.85-20.39-42.57-9.45-63.62,11.08-21.33,34.4-32.9,58.49-29.11,9.8,1.54,18.4,5.56,25.94,11.93,3.65,3.09,3.74,4.92,.52,8.17-2.53,2.54-3.16,2.36-6.33,.21-4.37-2.97-8.68-6.36-13.53-8.24-30.63-11.85-62.2,11.66-60.64,44.17,1.27,26.63,23.2,45.21,49.81,42.9,7.03-.61,13.74-2.24,20.25-4.95,2.95-1.23,4.36-2.93,4.23-6.36-.28-6.93-.08-13.87-.08-21.39Z" }), /* @__PURE__ */ me.createElement("path", { d: "M438.19,168.05c-.03,30.13-24.78,54.83-55.05,54.91-30.41,.08-55.41-24.93-55.19-55.22,.21-30.21,24.96-54.7,55.26-54.68,30.13,.02,55.02,24.91,54.99,54.99Zm-100.78,.48c.13,25.07,20.51,45.08,45.76,44.92,25.14-.16,45.52-20.58,45.38-45.45-.15-24.95-20.63-45.27-45.63-45.27-25.26,0-45.64,20.51-45.51,45.79Z" }), /* @__PURE__ */ me.createElement("path", { d: "M919.09,193.08c-3.56,8.15-6.98,16.06-10.46,23.95-1.84,4.16-2.82,4.71-7.23,4.5-3.94-.19-4.8-1.4-3.29-5.02,1.79-4.29,3.74-8.51,5.63-12.76,12.53-28.24,25.06-56.47,37.6-84.71,.47-1.06,.99-2.11,1.42-3.18,.8-1.99,1.95-3.46,4.37-3.4,2.23,.06,3.14,1.58,3.9,3.32,3.4,7.76,6.81,15.51,10.22,23.27,10.9,24.78,21.8,49.56,32.7,74.34,.2,.46,.39,.92,.59,1.38,1.84,4.26,1.78,5.56-.28,6.47-3.14,1.38-7.57,.01-8.95-3.02-3.31-7.25-6.55-14.53-9.66-21.87-1.02-2.41-2.22-3.62-5.12-3.59-16.32,.15-32.64,.07-48.95,.08-.65,0-1.31,.13-2.47,.26Zm51.02-9.24c-7.75-18.18-15.29-35.89-23.25-54.56-7.99,18.88-15.99,36.42-23.41,54.56h46.66Z" }), /* @__PURE__ */ me.createElement("path", { d: "M493.13,157.73c7.45-11.92,14.57-23.31,21.7-34.7,.79-1.27,1.77-2.46,2.34-3.82,1.81-4.31,5.23-5.12,9.38-4.61,3.16,.38,4.16,1.91,2.83,4.69-.71,1.49-1.72,2.83-2.61,4.24-8.42,13.34-16.85,26.67-25.26,40.02-.7,1.11-1.31,2.27-2.03,3.53,9.11,14.19,18.16,28.3,27.21,42.41,1.52,2.38,3.19,4.67,4.51,7.16,1.47,2.76,.46,4.49-2.59,4.85-4.07,.49-7.13-.4-9.54-4.41-7.29-12.08-15.05-23.88-22.63-35.78-.97-1.53-1.99-3.03-3.26-4.97-1,1.41-1.87,2.5-2.61,3.68-7.87,12.51-15.7,25.04-23.57,37.55-2.34,3.71-6.16,5.13-10.2,3.78-2.18-.73-2.84-2.23-1.71-4.26,1.05-1.88,2.25-3.69,3.4-5.51,8.64-13.59,17.29-27.18,25.92-40.78,.79-1.25,1.49-2.56,2.35-4.02-6.18-9.86-12.34-19.7-18.51-29.54-3.35-5.34-6.81-10.63-10.03-16.05-.86-1.45-1.8-3.68-1.24-4.88,.49-1.07,2.97-1.39,4.64-1.7,3.41-.64,5.49,1.06,7.24,3.95,7.12,11.8,14.43,23.48,21.68,35.2,.69,1.12,1.43,2.21,2.58,3.98Z" }), /* @__PURE__ */ me.createElement("path", { d: "M178.46,110.76c2.5-14.07,.48-26.55-9.47-38.36,1.79,.82,2.64,1,3.21,1.5,4.61,4.01,7.91,8.93,9.92,14.7,3.53,10.14,3.91,20.41,1.43,31.26-4.21-1.18-8.12-2.39-12.08-3.37-12.04-2.99-23.58-1.43-34.14,4.95-6.09,3.68-11.67,8.22-17.38,12.5-4.65,3.49-9.05,7.32-13.74,10.75-3.76,2.75-8.08,3.64-12.79,2.97-9.1-1.3-14.18-7.59-13-16.75,.53-4.1,1.73-8.11,2.41-12.2,2.68-16.08-.25-31.42-6.57-46.21-2.33-5.44-5.26-10.62-8.05-16.19,6.47-1.32,11.13-5.24,14.5-11.42-4.85-10.41-7.35-21.4-3.22-32.93,1.39-3.88,3.1-7.68,8.09-10.41,.84,1.22,1.6,2.77,2.75,3.91,6.82,6.8,13.75,13.48,20.6,20.25,2.07,2.05,4.3,2.55,7.23,2.02,7.63-1.38,14.91-.09,21.61,3.93,.64,.38,1.13,1,1.42,2.03-1.67-.59-3.31-1.27-5-1.76-6.28-1.82-12.6-1.62-18.65,.62-3.25,1.2-5.65,.71-8.2-1.28-7.31-5.73-14.68-11.37-22.28-17.25-2.44,4.25-2.5,9.31-1.7,14.28,.71,4.4,1.8,8.83,3.47,12.94,1.34,3.3,.72,5.57-1.33,8.13-3.4,4.23-7.45,7.51-13.08,9.47,15.5,23.18,20.02,48.01,12.55,75.04,5.04,.32,8.78,1.79,11.3,6.45,2.91-2.01,5.74-3.67,8.21-5.74,4.84-4.06,9.37-8.49,14.22-12.53,9.77-8.13,20.57-14.04,33.59-15.03,8.1-.62,15.86,.98,24.17,3.74Z" }), /* @__PURE__ */ me.createElement("path", { d: "M630.66,205.52c6.28-14.25,12.09-27.45,17.91-40.66,6.76-15.34,13.51-30.69,20.31-46.01,1.82-4.11,3.43-4.92,7.78-4.22,2.54,.41,3.43,1.66,2.74,4.19-.34,1.27-.98,2.46-1.52,3.67-14.18,31.66-28.35,63.33-42.59,94.96-1.04,2.3-1.47,5.5-4.97,5.49-3.51,0-3.88-3.22-4.9-5.53-14.15-32.04-28.26-64.09-42.33-96.17-.8-1.83-2.99-4.26-.46-5.69,1.89-1.07,4.88-.99,7.09-.38,1.3,.36,2.29,2.64,3,4.24,5.71,12.9,11.32,25.85,16.97,38.78,6.24,14.3,12.48,28.6,18.74,42.89,.51,1.17,1.14,2.28,2.22,4.43Z" }), /* @__PURE__ */ me.createElement("path", { d: "M252.54,175.37c0,5.75,0,10.86,0,15.98,0,8.31,.03,16.61-.06,24.92-.05,4.25-1.74,5.57-5.92,5.27-2.62-.19-3.95-1.49-4.1-4.05-.07-1.16-.04-2.32-.04-3.49,0-30.57,0-61.13,0-91.7,0-1-.05-2,.02-2.99,.26-3.67,1.17-4.65,4.95-4.68,8.66-.08,17.31-.03,25.97-.03,10.16,0,20.31-.04,30.47,.02,4.01,.03,5.01,1.01,5.1,4.44,.1,3.62-.88,4.8-4.63,4.84-8.82,.1-17.65,.03-26.47,.04-8.13,0-16.27,0-24.81,0v42.16c1.7,0,3.46,0,5.21,0,12.65,0,25.3-.04,37.96,.02,4.32,.02,5.86,1.54,5.57,5.08-.24,2.89-1.34,4.06-4.5,4.13-5.32,.12-10.65,.04-15.98,.04-9.3,0-18.6,0-28.73,0Z" }), /* @__PURE__ */ me.createElement("path", { d: "M837.38,212.31c3.87,0,6.86,0,9.85,0,11.65,0,23.3-.04,34.95,.02,3.58,.02,4.63,1.09,4.76,4.25,.13,3.39-1.14,4.9-4.68,4.91-16.64,.07-33.28,.07-49.93,0-4.24-.02-5-1.06-5-6.14-.02-30.39-.01-60.78-.01-91.17,0-1.49-.05-2.99,.01-4.48,.17-4.11,1.48-5.29,5.55-5.1,3.14,.15,4.21,1.09,4.47,4.11,.11,1.32,.03,2.66,.03,3.98,0,27.9,0,55.8,0,83.69v5.92Z" }), /* @__PURE__ */ me.createElement("path", { d: "M757.17,212.31c10.94,0,21.07,0,31.19,0,4.16,0,8.32-.03,12.47,0,4.95,.04,5.72,.7,5.67,4.68-.05,3.87-.84,4.49-5.92,4.53-4.32,.03-8.65,0-12.97,0-11.31,0-22.62,.02-33.93,0-5.85-.01-6.44-.55-6.44-6.13-.02-31.53-.02-63.07,0-94.6,0-5.17,1.09-6.37,5.38-6.19,3.36,.14,4.3,1.05,4.54,4.56,.09,1.32,.02,2.65,.02,3.98,0,27.72,0,55.43,0,83.15,0,1.79,0,3.59,0,6.01Z" }), /* @__PURE__ */ me.createElement("path", { d: "M711.21,167.82c0,15.93,.02,31.85-.01,47.78-.01,4.86-1.07,5.97-5.22,5.93-4.11-.04-4.87-.93-4.87-6.19-.02-26.55-.01-53.09-.01-79.64,0-4.98-.03-9.95,0-14.93,.04-5.24,.77-6.13,4.88-6.17,4.28-.04,5.21,1.04,5.21,6.43,.02,15.6,0,31.19,0,46.79Z" }), /* @__PURE__ */ me.createElement("path", { d: "M166.13,265.5c-.13-4.64-.5-9.28-.35-13.9,.46-14.43,1.12-28.85,1.71-43.63-4.65,2.53-9.03,5.35-13.76,7.37-4.65,1.99-9.64,3.18-14.47,4.73-.23-.46-.45-.93-.68-1.39,1.27-.76,2.54-1.54,3.82-2.29,17.63-10.23,31.05-24.31,39.46-42.96,6.05-13.42,7.49-27.42,5.25-41.88-.07-.47,0-.96,.54-1.66,.45,.89,1.07,1.74,1.33,2.68,6.48,23.36,3.42,45.05-11.56,64.56-1.6,2.08-2.29,4.16-2.62,6.73-2.5,19.59-5.18,39.15-7.84,58.72-.13,.96-.62,1.86-.94,2.79l.12,.12Z" }), /* @__PURE__ */ me.createElement("path", { d: "M154.4,32.58c6.59-6.55,13.14-13.13,19.77-19.63,2.1-2.06,3.43-1.96,4.69,.49,7.07,13.76,6.87,33.67-4.66,45.73-.55,.57-1.21,1.03-2.12,1.39,2.6-6.43,5.35-12.74,5.8-19.75,.44-7.01,0-13.88-2.42-21.03-6.54,5.37-13.02,10.2-21.05,12.81Z" }), /* @__PURE__ */ me.createElement("path", { d: "M69.79,165.74c3.25-9.43,.25-18.6-1.2-28.27,7.87,6.93,8.46,20.85,1.2,28.27Z" }), /* @__PURE__ */ me.createElement("path", { d: "M87.69,220.73c2.96-3.13,6.16-3.11,9.37-1.73,3.1,1.34,4.69,3.86,4.76,7.54-5.95,.79-10.29-1.22-14.13-5.81Z" }), /* @__PURE__ */ me.createElement("path", { d: "M114.11,103.74c1.77-7.92,7.64-10.31,14-5.8-3.43,4.68-7.93,6.41-14,5.8Z" })))
);
function Me(e, ...r) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return r.forEach((o) => n.searchParams.append("args[]", o)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
var vt = { exports: {} }, H = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qr;
function Uo() {
  if (Qr) return H;
  Qr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, b = e ? Symbol.for("react.concurrent_mode") : 60111, _ = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, w = e ? Symbol.for("react.lazy") : 60116, l = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, Y = e ? Symbol.for("react.responder") : 60118, ne = e ? Symbol.for("react.scope") : 60119;
  function L(S) {
    if (typeof S == "object" && S !== null) {
      var K = S.$$typeof;
      switch (K) {
        case r:
          switch (S = S.type, S) {
            case y:
            case b:
            case o:
            case u:
            case i:
            case v:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case d:
                case _:
                case w:
                case x:
                case f:
                  return S;
                default:
                  return K;
              }
          }
        case n:
          return K;
      }
    }
  }
  function $(S) {
    return L(S) === b;
  }
  return H.AsyncMode = y, H.ConcurrentMode = b, H.ContextConsumer = d, H.ContextProvider = f, H.Element = r, H.ForwardRef = _, H.Fragment = o, H.Lazy = w, H.Memo = x, H.Portal = n, H.Profiler = u, H.StrictMode = i, H.Suspense = v, H.isAsyncMode = function(S) {
    return $(S) || L(S) === y;
  }, H.isConcurrentMode = $, H.isContextConsumer = function(S) {
    return L(S) === d;
  }, H.isContextProvider = function(S) {
    return L(S) === f;
  }, H.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === r;
  }, H.isForwardRef = function(S) {
    return L(S) === _;
  }, H.isFragment = function(S) {
    return L(S) === o;
  }, H.isLazy = function(S) {
    return L(S) === w;
  }, H.isMemo = function(S) {
    return L(S) === x;
  }, H.isPortal = function(S) {
    return L(S) === n;
  }, H.isProfiler = function(S) {
    return L(S) === u;
  }, H.isStrictMode = function(S) {
    return L(S) === i;
  }, H.isSuspense = function(S) {
    return L(S) === v;
  }, H.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === o || S === b || S === u || S === i || S === v || S === E || typeof S == "object" && S !== null && (S.$$typeof === w || S.$$typeof === x || S.$$typeof === f || S.$$typeof === d || S.$$typeof === _ || S.$$typeof === I || S.$$typeof === Y || S.$$typeof === ne || S.$$typeof === l);
  }, H.typeOf = L, H;
}
var Z = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jr;
function Yo() {
  return Jr || (Jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, b = e ? Symbol.for("react.concurrent_mode") : 60111, _ = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, w = e ? Symbol.for("react.lazy") : 60116, l = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, Y = e ? Symbol.for("react.responder") : 60118, ne = e ? Symbol.for("react.scope") : 60119;
    function L(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === o || k === b || k === u || k === i || k === v || k === E || typeof k == "object" && k !== null && (k.$$typeof === w || k.$$typeof === x || k.$$typeof === f || k.$$typeof === d || k.$$typeof === _ || k.$$typeof === I || k.$$typeof === Y || k.$$typeof === ne || k.$$typeof === l);
    }
    function $(k) {
      if (typeof k == "object" && k !== null) {
        var Se = k.$$typeof;
        switch (Se) {
          case r:
            var je = k.type;
            switch (je) {
              case y:
              case b:
              case o:
              case u:
              case i:
              case v:
                return je;
              default:
                var at = je && je.$$typeof;
                switch (at) {
                  case d:
                  case _:
                  case w:
                  case x:
                  case f:
                    return at;
                  default:
                    return Se;
                }
            }
          case n:
            return Se;
        }
      }
    }
    var S = y, K = b, le = d, ve = f, he = r, a = _, M = o, q = w, X = x, ye = n, de = u, ge = i, j = v, we = !1;
    function Ae(k) {
      return we || (we = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(k) || $(k) === y;
    }
    function C(k) {
      return $(k) === b;
    }
    function c(k) {
      return $(k) === d;
    }
    function g(k) {
      return $(k) === f;
    }
    function O(k) {
      return typeof k == "object" && k !== null && k.$$typeof === r;
    }
    function R(k) {
      return $(k) === _;
    }
    function A(k) {
      return $(k) === o;
    }
    function D(k) {
      return $(k) === w;
    }
    function N(k) {
      return $(k) === x;
    }
    function B(k) {
      return $(k) === n;
    }
    function F(k) {
      return $(k) === u;
    }
    function W(k) {
      return $(k) === i;
    }
    function Ee(k) {
      return $(k) === v;
    }
    Z.AsyncMode = S, Z.ConcurrentMode = K, Z.ContextConsumer = le, Z.ContextProvider = ve, Z.Element = he, Z.ForwardRef = a, Z.Fragment = M, Z.Lazy = q, Z.Memo = X, Z.Portal = ye, Z.Profiler = de, Z.StrictMode = ge, Z.Suspense = j, Z.isAsyncMode = Ae, Z.isConcurrentMode = C, Z.isContextConsumer = c, Z.isContextProvider = g, Z.isElement = O, Z.isForwardRef = R, Z.isFragment = A, Z.isLazy = D, Z.isMemo = N, Z.isPortal = B, Z.isProfiler = F, Z.isStrictMode = W, Z.isSuspense = Ee, Z.isValidElementType = L, Z.typeOf = $;
  }()), Z;
}
var en;
function Tn() {
  return en || (en = 1, process.env.NODE_ENV === "production" ? vt.exports = Uo() : vt.exports = Yo()), vt.exports;
}
var bt = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Kt, tn;
function zo() {
  if (tn) return Kt;
  tn = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var f = {}, d = 0; d < 10; d++)
        f["_" + String.fromCharCode(d)] = d;
      var y = Object.getOwnPropertyNames(f).map(function(_) {
        return f[_];
      });
      if (y.join("") !== "0123456789")
        return !1;
      var b = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(_) {
        b[_] = _;
      }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Kt = i() ? Object.assign : function(u, f) {
    for (var d, y = o(u), b, _ = 1; _ < arguments.length; _++) {
      d = Object(arguments[_]);
      for (var v in d)
        r.call(d, v) && (y[v] = d[v]);
      if (e) {
        b = e(d);
        for (var E = 0; E < b.length; E++)
          n.call(d, b[E]) && (y[b[E]] = d[b[E]]);
      }
    }
    return y;
  }, Kt;
}
var Ht, rn;
function ir() {
  if (rn) return Ht;
  rn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ht = e, Ht;
}
var Zt, nn;
function wn() {
  return nn || (nn = 1, Zt = Function.call.bind(Object.prototype.hasOwnProperty)), Zt;
}
var Xt, on;
function qo() {
  if (on) return Xt;
  on = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ ir(), n = {}, o = /* @__PURE__ */ wn();
    e = function(u) {
      var f = "Warning: " + u;
      typeof console < "u" && console.error(f);
      try {
        throw new Error(f);
      } catch {
      }
    };
  }
  function i(u, f, d, y, b) {
    if (process.env.NODE_ENV !== "production") {
      for (var _ in u)
        if (o(u, _)) {
          var v;
          try {
            if (typeof u[_] != "function") {
              var E = Error(
                (y || "React class") + ": " + d + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            v = u[_](f, _, y, d, null, r);
          } catch (w) {
            v = w;
          }
          if (v && !(v instanceof Error) && e(
            (y || "React class") + ": type specification of " + d + " `" + _ + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in n)) {
            n[v.message] = !0;
            var x = b ? b() : "";
            e(
              "Failed " + d + " type: " + v.message + (x ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Xt = i, Xt;
}
var Qt, an;
function Go() {
  if (an) return Qt;
  an = 1;
  var e = Tn(), r = zo(), n = /* @__PURE__ */ ir(), o = /* @__PURE__ */ wn(), i = /* @__PURE__ */ qo(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(d) {
    var y = "Warning: " + d;
    typeof console < "u" && console.error(y);
    try {
      throw new Error(y);
    } catch {
    }
  });
  function f() {
    return null;
  }
  return Qt = function(d, y) {
    var b = typeof Symbol == "function" && Symbol.iterator, _ = "@@iterator";
    function v(C) {
      var c = C && (b && C[b] || C[_]);
      if (typeof c == "function")
        return c;
    }
    var E = "<<anonymous>>", x = {
      array: Y("array"),
      bigint: Y("bigint"),
      bool: Y("boolean"),
      func: Y("function"),
      number: Y("number"),
      object: Y("object"),
      string: Y("string"),
      symbol: Y("symbol"),
      any: ne(),
      arrayOf: L,
      element: $(),
      elementType: S(),
      instanceOf: K,
      node: a(),
      objectOf: ve,
      oneOf: le,
      oneOfType: he,
      shape: q,
      exact: X
    };
    function w(C, c) {
      return C === c ? C !== 0 || 1 / C === 1 / c : C !== C && c !== c;
    }
    function l(C, c) {
      this.message = C, this.data = c && typeof c == "object" ? c : {}, this.stack = "";
    }
    l.prototype = Error.prototype;
    function I(C) {
      if (process.env.NODE_ENV !== "production")
        var c = {}, g = 0;
      function O(A, D, N, B, F, W, Ee) {
        if (B = B || E, W = W || N, Ee !== n) {
          if (y) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Se = B + ":" + N;
            !c[Se] && // Avoid spamming the console because they are often not actionable except for lib authors
            g < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), c[Se] = !0, g++);
          }
        }
        return D[N] == null ? A ? D[N] === null ? new l("The " + F + " `" + W + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new l("The " + F + " `" + W + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : C(D, N, B, F, W);
      }
      var R = O.bind(null, !1);
      return R.isRequired = O.bind(null, !0), R;
    }
    function Y(C) {
      function c(g, O, R, A, D, N) {
        var B = g[O], F = ge(B);
        if (F !== C) {
          var W = j(B);
          return new l(
            "Invalid " + A + " `" + D + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected ") + ("`" + C + "`."),
            { expectedType: C }
          );
        }
        return null;
      }
      return I(c);
    }
    function ne() {
      return I(f);
    }
    function L(C) {
      function c(g, O, R, A, D) {
        if (typeof C != "function")
          return new l("Property `" + D + "` of component `" + R + "` has invalid PropType notation inside arrayOf.");
        var N = g[O];
        if (!Array.isArray(N)) {
          var B = ge(N);
          return new l("Invalid " + A + " `" + D + "` of type " + ("`" + B + "` supplied to `" + R + "`, expected an array."));
        }
        for (var F = 0; F < N.length; F++) {
          var W = C(N, F, R, A, D + "[" + F + "]", n);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return I(c);
    }
    function $() {
      function C(c, g, O, R, A) {
        var D = c[g];
        if (!d(D)) {
          var N = ge(D);
          return new l("Invalid " + R + " `" + A + "` of type " + ("`" + N + "` supplied to `" + O + "`, expected a single ReactElement."));
        }
        return null;
      }
      return I(C);
    }
    function S() {
      function C(c, g, O, R, A) {
        var D = c[g];
        if (!e.isValidElementType(D)) {
          var N = ge(D);
          return new l("Invalid " + R + " `" + A + "` of type " + ("`" + N + "` supplied to `" + O + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return I(C);
    }
    function K(C) {
      function c(g, O, R, A, D) {
        if (!(g[O] instanceof C)) {
          var N = C.name || E, B = Ae(g[O]);
          return new l("Invalid " + A + " `" + D + "` of type " + ("`" + B + "` supplied to `" + R + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return I(c);
    }
    function le(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), f;
      function c(g, O, R, A, D) {
        for (var N = g[O], B = 0; B < C.length; B++)
          if (w(N, C[B]))
            return null;
        var F = JSON.stringify(C, function(Ee, k) {
          var Se = j(k);
          return Se === "symbol" ? String(k) : k;
        });
        return new l("Invalid " + A + " `" + D + "` of value `" + String(N) + "` " + ("supplied to `" + R + "`, expected one of " + F + "."));
      }
      return I(c);
    }
    function ve(C) {
      function c(g, O, R, A, D) {
        if (typeof C != "function")
          return new l("Property `" + D + "` of component `" + R + "` has invalid PropType notation inside objectOf.");
        var N = g[O], B = ge(N);
        if (B !== "object")
          return new l("Invalid " + A + " `" + D + "` of type " + ("`" + B + "` supplied to `" + R + "`, expected an object."));
        for (var F in N)
          if (o(N, F)) {
            var W = C(N, F, R, A, D + "." + F, n);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return I(c);
    }
    function he(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), f;
      for (var c = 0; c < C.length; c++) {
        var g = C[c];
        if (typeof g != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + we(g) + " at index " + c + "."
          ), f;
      }
      function O(R, A, D, N, B) {
        for (var F = [], W = 0; W < C.length; W++) {
          var Ee = C[W], k = Ee(R, A, D, N, B, n);
          if (k == null)
            return null;
          k.data && o(k.data, "expectedType") && F.push(k.data.expectedType);
        }
        var Se = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new l("Invalid " + N + " `" + B + "` supplied to " + ("`" + D + "`" + Se + "."));
      }
      return I(O);
    }
    function a() {
      function C(c, g, O, R, A) {
        return ye(c[g]) ? null : new l("Invalid " + R + " `" + A + "` supplied to " + ("`" + O + "`, expected a ReactNode."));
      }
      return I(C);
    }
    function M(C, c, g, O, R) {
      return new l(
        (C || "React class") + ": " + c + " type `" + g + "." + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + R + "`."
      );
    }
    function q(C) {
      function c(g, O, R, A, D) {
        var N = g[O], B = ge(N);
        if (B !== "object")
          return new l("Invalid " + A + " `" + D + "` of type `" + B + "` " + ("supplied to `" + R + "`, expected `object`."));
        for (var F in C) {
          var W = C[F];
          if (typeof W != "function")
            return M(R, A, D, F, j(W));
          var Ee = W(N, F, R, A, D + "." + F, n);
          if (Ee)
            return Ee;
        }
        return null;
      }
      return I(c);
    }
    function X(C) {
      function c(g, O, R, A, D) {
        var N = g[O], B = ge(N);
        if (B !== "object")
          return new l("Invalid " + A + " `" + D + "` of type `" + B + "` " + ("supplied to `" + R + "`, expected `object`."));
        var F = r({}, g[O], C);
        for (var W in F) {
          var Ee = C[W];
          if (o(C, W) && typeof Ee != "function")
            return M(R, A, D, W, j(Ee));
          if (!Ee)
            return new l(
              "Invalid " + A + " `" + D + "` key `" + W + "` supplied to `" + R + "`.\nBad object: " + JSON.stringify(g[O], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(C), null, "  ")
            );
          var k = Ee(N, W, R, A, D + "." + W, n);
          if (k)
            return k;
        }
        return null;
      }
      return I(c);
    }
    function ye(C) {
      switch (typeof C) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !C;
        case "object":
          if (Array.isArray(C))
            return C.every(ye);
          if (C === null || d(C))
            return !0;
          var c = v(C);
          if (c) {
            var g = c.call(C), O;
            if (c !== C.entries) {
              for (; !(O = g.next()).done; )
                if (!ye(O.value))
                  return !1;
            } else
              for (; !(O = g.next()).done; ) {
                var R = O.value;
                if (R && !ye(R[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function de(C, c) {
      return C === "symbol" ? !0 : c ? c["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && c instanceof Symbol : !1;
    }
    function ge(C) {
      var c = typeof C;
      return Array.isArray(C) ? "array" : C instanceof RegExp ? "object" : de(c, C) ? "symbol" : c;
    }
    function j(C) {
      if (typeof C > "u" || C === null)
        return "" + C;
      var c = ge(C);
      if (c === "object") {
        if (C instanceof Date)
          return "date";
        if (C instanceof RegExp)
          return "regexp";
      }
      return c;
    }
    function we(C) {
      var c = j(C);
      switch (c) {
        case "array":
        case "object":
          return "an " + c;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + c;
        default:
          return c;
      }
    }
    function Ae(C) {
      return !C.constructor || !C.constructor.name ? E : C.constructor.name;
    }
    return x.checkPropTypes = i, x.resetWarningCache = i.resetWarningCache, x.PropTypes = x, x;
  }, Qt;
}
var Jt, sn;
function Ko() {
  if (sn) return Jt;
  sn = 1;
  var e = /* @__PURE__ */ ir();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, Jt = function() {
    function o(f, d, y, b, _, v) {
      if (v !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var u = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return u.PropTypes = u, u;
  }, Jt;
}
var un;
function Ho() {
  if (un) return bt.exports;
  if (un = 1, process.env.NODE_ENV !== "production") {
    var e = Tn(), r = !0;
    bt.exports = /* @__PURE__ */ Go()(e.isElement, r);
  } else
    bt.exports = /* @__PURE__ */ Ko()();
  return bt.exports;
}
var Zo = /* @__PURE__ */ Ho();
const Xe = /* @__PURE__ */ _n(Zo);
var Et = { exports: {} }, Q = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cn;
function Xo() {
  if (cn) return Q;
  cn = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.consumer"), f = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), E = Symbol.for("react.view_transition"), x = Symbol.for("react.client.reference");
  function w(l) {
    if (typeof l == "object" && l !== null) {
      var I = l.$$typeof;
      switch (I) {
        case e:
          switch (l = l.type, l) {
            case n:
            case i:
            case o:
            case y:
            case b:
            case E:
              return l;
            default:
              switch (l = l && l.$$typeof, l) {
                case f:
                case d:
                case v:
                case _:
                  return l;
                case u:
                  return l;
                default:
                  return I;
              }
          }
        case r:
          return I;
      }
    }
  }
  return Q.ContextConsumer = u, Q.ContextProvider = f, Q.Element = e, Q.ForwardRef = d, Q.Fragment = n, Q.Lazy = v, Q.Memo = _, Q.Portal = r, Q.Profiler = i, Q.StrictMode = o, Q.Suspense = y, Q.SuspenseList = b, Q.isContextConsumer = function(l) {
    return w(l) === u;
  }, Q.isContextProvider = function(l) {
    return w(l) === f;
  }, Q.isElement = function(l) {
    return typeof l == "object" && l !== null && l.$$typeof === e;
  }, Q.isForwardRef = function(l) {
    return w(l) === d;
  }, Q.isFragment = function(l) {
    return w(l) === n;
  }, Q.isLazy = function(l) {
    return w(l) === v;
  }, Q.isMemo = function(l) {
    return w(l) === _;
  }, Q.isPortal = function(l) {
    return w(l) === r;
  }, Q.isProfiler = function(l) {
    return w(l) === i;
  }, Q.isStrictMode = function(l) {
    return w(l) === o;
  }, Q.isSuspense = function(l) {
    return w(l) === y;
  }, Q.isSuspenseList = function(l) {
    return w(l) === b;
  }, Q.isValidElementType = function(l) {
    return typeof l == "string" || typeof l == "function" || l === n || l === i || l === o || l === y || l === b || typeof l == "object" && l !== null && (l.$$typeof === v || l.$$typeof === _ || l.$$typeof === f || l.$$typeof === u || l.$$typeof === d || l.$$typeof === x || l.getModuleId !== void 0);
  }, Q.typeOf = w, Q;
}
var J = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ln;
function Qo() {
  return ln || (ln = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l) {
      if (typeof l == "object" && l !== null) {
        var I = l.$$typeof;
        switch (I) {
          case r:
            switch (l = l.type, l) {
              case o:
              case u:
              case i:
              case b:
              case _:
              case x:
                return l;
              default:
                switch (l = l && l.$$typeof, l) {
                  case d:
                  case y:
                  case E:
                  case v:
                    return l;
                  case f:
                    return l;
                  default:
                    return I;
                }
            }
          case n:
            return I;
        }
      }
    }
    var r = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.consumer"), d = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), x = Symbol.for("react.view_transition"), w = Symbol.for("react.client.reference");
    J.ContextConsumer = f, J.ContextProvider = d, J.Element = r, J.ForwardRef = y, J.Fragment = o, J.Lazy = E, J.Memo = v, J.Portal = n, J.Profiler = u, J.StrictMode = i, J.Suspense = b, J.SuspenseList = _, J.isContextConsumer = function(l) {
      return e(l) === f;
    }, J.isContextProvider = function(l) {
      return e(l) === d;
    }, J.isElement = function(l) {
      return typeof l == "object" && l !== null && l.$$typeof === r;
    }, J.isForwardRef = function(l) {
      return e(l) === y;
    }, J.isFragment = function(l) {
      return e(l) === o;
    }, J.isLazy = function(l) {
      return e(l) === E;
    }, J.isMemo = function(l) {
      return e(l) === v;
    }, J.isPortal = function(l) {
      return e(l) === n;
    }, J.isProfiler = function(l) {
      return e(l) === u;
    }, J.isStrictMode = function(l) {
      return e(l) === i;
    }, J.isSuspense = function(l) {
      return e(l) === b;
    }, J.isSuspenseList = function(l) {
      return e(l) === _;
    }, J.isValidElementType = function(l) {
      return typeof l == "string" || typeof l == "function" || l === o || l === u || l === i || l === b || l === _ || typeof l == "object" && l !== null && (l.$$typeof === E || l.$$typeof === v || l.$$typeof === d || l.$$typeof === f || l.$$typeof === y || l.$$typeof === w || l.getModuleId !== void 0);
    }, J.typeOf = e;
  }()), J;
}
var fn;
function Jo() {
  return fn || (fn = 1, process.env.NODE_ENV === "production" ? Et.exports = /* @__PURE__ */ Xo() : Et.exports = /* @__PURE__ */ Qo()), Et.exports;
}
var Rn = /* @__PURE__ */ Jo();
function Ie(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function xn(e) {
  if (/* @__PURE__ */ or.isValidElement(e) || Rn.isValidElementType(e) || !Ie(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((n) => {
    r[n] = xn(e[n]);
  }), r;
}
function Te(e, r, n = {
  clone: !0
}) {
  const o = n.clone ? {
    ...e
  } : e;
  return Ie(e) && Ie(r) && Object.keys(r).forEach((i) => {
    /* @__PURE__ */ or.isValidElement(r[i]) || Rn.isValidElementType(r[i]) ? o[i] = r[i] : Ie(r[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Ie(e[i]) ? o[i] = Te(e[i], r[i], n) : n.clone ? o[i] = Ie(r[i]) ? xn(r[i]) : r[i] : o[i] = r[i];
  }), o;
}
const ei = (e) => {
  const r = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return r.sort((n, o) => n.val - o.val), r.reduce((n, o) => ({
    ...n,
    [o.key]: o.val
  }), {});
};
function ti(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5,
    ...i
  } = e, u = ei(r), f = Object.keys(u);
  function d(E) {
    return `@media (min-width:${typeof r[E] == "number" ? r[E] : E}${n})`;
  }
  function y(E) {
    return `@media (max-width:${(typeof r[E] == "number" ? r[E] : E) - o / 100}${n})`;
  }
  function b(E, x) {
    const w = f.indexOf(x);
    return `@media (min-width:${typeof r[E] == "number" ? r[E] : E}${n}) and (max-width:${(w !== -1 && typeof r[f[w]] == "number" ? r[f[w]] : x) - o / 100}${n})`;
  }
  function _(E) {
    return f.indexOf(E) + 1 < f.length ? b(E, f[f.indexOf(E) + 1]) : d(E);
  }
  function v(E) {
    const x = f.indexOf(E);
    return x === 0 ? d(f[1]) : x === f.length - 1 ? y(f[x]) : b(E, f[f.indexOf(E) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: f,
    values: u,
    up: d,
    down: y,
    between: b,
    only: _,
    not: v,
    unit: n,
    ...i
  };
}
function ri(e, r) {
  if (!e.containerQueries)
    return r;
  const n = Object.keys(r).filter((o) => o.startsWith("@container")).sort((o, i) => {
    var f, d;
    const u = /min-width:\s*([0-9.]+)/;
    return +(((f = o.match(u)) == null ? void 0 : f[1]) || 0) - +(((d = i.match(u)) == null ? void 0 : d[1]) || 0);
  });
  return n.length ? n.reduce((o, i) => {
    const u = r[i];
    return delete o[i], o[i] = u, o;
  }, {
    ...r
  }) : r;
}
function ni(e, r) {
  return r === "@" || r.startsWith("@") && (e.some((n) => r.startsWith(`@${n}`)) || !!r.match(/^@\d/));
}
function oi(e, r) {
  const n = r.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${r})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Me(18, `(${r})`));
    return null;
  }
  const [, o, i] = n, u = Number.isNaN(+o) ? o || 0 : +o;
  return e.containerQueries(i).up(u);
}
function ii(e) {
  const r = (u, f) => u.replace("@media", f ? `@container ${f}` : "@container");
  function n(u, f) {
    u.up = (...d) => r(e.breakpoints.up(...d), f), u.down = (...d) => r(e.breakpoints.down(...d), f), u.between = (...d) => r(e.breakpoints.between(...d), f), u.only = (...d) => r(e.breakpoints.only(...d), f), u.not = (...d) => {
      const y = r(e.breakpoints.not(...d), f);
      return y.includes("not all and") ? y.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : y;
    };
  }
  const o = {}, i = (u) => (n(o, u), o);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const ai = {
  borderRadius: 4
}, Ne = process.env.NODE_ENV !== "production" ? Xe.oneOfType([Xe.number, Xe.string, Xe.object, Xe.array]) : {};
function rt(e, r) {
  return r ? Te(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Tt = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, dn = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Tt[e]}px)`
}, si = {
  containerQueries: (e) => ({
    up: (r) => {
      let n = typeof r == "number" ? r : Tt[r] || r;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function $e(e, r, n) {
  const o = e.theme || {};
  if (Array.isArray(r)) {
    const u = o.breakpoints || dn;
    return r.reduce((f, d, y) => (f[u.up(u.keys[y])] = n(r[y]), f), {});
  }
  if (typeof r == "object") {
    const u = o.breakpoints || dn;
    return Object.keys(r).reduce((f, d) => {
      if (ni(u.keys, d)) {
        const y = oi(o.containerQueries ? o : si, d);
        y && (f[y] = n(r[d], d));
      } else if (Object.keys(u.values || Tt).includes(d)) {
        const y = u.up(d);
        f[y] = n(r[d], d);
      } else {
        const y = d;
        f[y] = r[y];
      }
      return f;
    }, {});
  }
  return n(r);
}
function ui(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((o, i) => {
    const u = e.up(i);
    return o[u] = {}, o;
  }, {})) || {};
}
function ci(e, r) {
  return e.reduce((n, o) => {
    const i = n[o];
    return (!i || Object.keys(i).length === 0) && delete n[o], n;
  }, r);
}
function On(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Me(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function wt(e, r, n = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${r}`.split(".").reduce((i, u) => i && i[u] ? i[u] : null, e);
    if (o != null)
      return o;
  }
  return r.split(".").reduce((o, i) => o && o[i] != null ? o[i] : null, e);
}
function _t(e, r, n, o = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || o : i = wt(e, n) || o, r && (i = r(i, o, e)), i;
}
function fe(e) {
  const {
    prop: r,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: i
  } = e, u = (f) => {
    if (f[r] == null)
      return null;
    const d = f[r], y = f.theme, b = wt(y, o) || {};
    return $e(f, d, (v) => {
      let E = _t(b, i, v);
      return v === E && typeof v == "string" && (E = _t(b, i, `${r}${v === "default" ? "" : On(v)}`, v)), n === !1 ? E : {
        [n]: E
      };
    });
  };
  return u.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: Ne
  } : {}, u.filterProps = [r], u;
}
function li(e) {
  const r = {};
  return (n) => (r[n] === void 0 && (r[n] = e(n)), r[n]);
}
const fi = {
  m: "margin",
  p: "padding"
}, di = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, pn = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, pi = li((e) => {
  if (e.length > 2)
    if (pn[e])
      e = pn[e];
    else
      return [e];
  const [r, n] = e.split(""), o = fi[r], i = di[n] || "";
  return Array.isArray(i) ? i.map((u) => o + u) : [o + i];
}), Rt = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], xt = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], mi = [...Rt, ...xt];
function ot(e, r, n, o) {
  const i = wt(e, r, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (u) => typeof u == "string" ? u : (process.env.NODE_ENV !== "production" && typeof u != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${u}.`), typeof i == "string" ? i.startsWith("var(") && u === 0 ? 0 : i.startsWith("var(") && u === 1 ? i : `calc(${u} * ${i})` : i * u) : Array.isArray(i) ? (u) => {
    if (typeof u == "string")
      return u;
    const f = Math.abs(u);
    process.env.NODE_ENV !== "production" && (Number.isInteger(f) ? f > i.length - 1 && console.error([`MUI: The value provided (${f}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${f} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`)));
    const d = i[f];
    return u >= 0 ? d : typeof d == "number" ? -d : typeof d == "string" && d.startsWith("var(") ? `calc(-1 * ${d})` : `-${d}`;
  } : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function ar(e) {
  return ot(e, "spacing", 8, "spacing");
}
function it(e, r) {
  return typeof r == "string" || r == null ? r : e(r);
}
function hi(e, r) {
  return (n) => e.reduce((o, i) => (o[i] = it(r, n), o), {});
}
function gi(e, r, n, o) {
  if (!r.includes(n))
    return null;
  const i = pi(n), u = hi(i, o), f = e[n];
  return $e(e, f, u);
}
function kn(e, r) {
  const n = ar(e.theme);
  return Object.keys(e).map((o) => gi(e, r, o, n)).reduce(rt, {});
}
function ue(e) {
  return kn(e, Rt);
}
ue.propTypes = process.env.NODE_ENV !== "production" ? Rt.reduce((e, r) => (e[r] = Ne, e), {}) : {};
ue.filterProps = Rt;
function ce(e) {
  return kn(e, xt);
}
ce.propTypes = process.env.NODE_ENV !== "production" ? xt.reduce((e, r) => (e[r] = Ne, e), {}) : {};
ce.filterProps = xt;
process.env.NODE_ENV !== "production" && mi.reduce((e, r) => (e[r] = Ne, e), {});
function $n(e = 8, r = ar({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((u) => {
    const f = r(u);
    return typeof f == "number" ? `${f}px` : f;
  }).join(" "));
  return n.mui = !0, n;
}
function Ot(...e) {
  const r = e.reduce((o, i) => (i.filterProps.forEach((u) => {
    o[u] = i;
  }), o), {}), n = (o) => Object.keys(o).reduce((i, u) => r[u] ? rt(i, r[u](o)) : i, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, i) => Object.assign(o, i.propTypes), {}) : {}, n.filterProps = e.reduce((o, i) => o.concat(i.filterProps), []), n;
}
function Re(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function xe(e, r) {
  return fe({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const yi = xe("border", Re), vi = xe("borderTop", Re), bi = xe("borderRight", Re), Ei = xe("borderBottom", Re), Si = xe("borderLeft", Re), Ci = xe("borderColor"), _i = xe("borderTopColor"), Ti = xe("borderRightColor"), wi = xe("borderBottomColor"), Ri = xe("borderLeftColor"), xi = xe("outline", Re), Oi = xe("outlineColor"), kt = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = ot(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: it(r, o)
    });
    return $e(e, e.borderRadius, n);
  }
  return null;
};
kt.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Ne
} : {};
kt.filterProps = ["borderRadius"];
Ot(yi, vi, bi, Ei, Si, Ci, _i, Ti, wi, Ri, kt, xi, Oi);
const $t = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = ot(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: it(r, o)
    });
    return $e(e, e.gap, n);
  }
  return null;
};
$t.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Ne
} : {};
$t.filterProps = ["gap"];
const At = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = ot(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: it(r, o)
    });
    return $e(e, e.columnGap, n);
  }
  return null;
};
At.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Ne
} : {};
At.filterProps = ["columnGap"];
const Pt = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = ot(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: it(r, o)
    });
    return $e(e, e.rowGap, n);
  }
  return null;
};
Pt.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Ne
} : {};
Pt.filterProps = ["rowGap"];
const ki = fe({
  prop: "gridColumn"
}), $i = fe({
  prop: "gridRow"
}), Ai = fe({
  prop: "gridAutoFlow"
}), Pi = fe({
  prop: "gridAutoColumns"
}), Ii = fe({
  prop: "gridAutoRows"
}), Mi = fe({
  prop: "gridTemplateColumns"
}), Di = fe({
  prop: "gridTemplateRows"
}), Ni = fe({
  prop: "gridTemplateAreas"
}), ji = fe({
  prop: "gridArea"
});
Ot($t, At, Pt, ki, $i, Ai, Pi, Ii, Mi, Di, Ni, ji);
function Ge(e, r) {
  return r === "grey" ? r : e;
}
const Bi = fe({
  prop: "color",
  themeKey: "palette",
  transform: Ge
}), Fi = fe({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ge
}), Li = fe({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ge
});
Ot(Bi, Fi, Li);
function _e(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Vi = fe({
  prop: "width",
  transform: _e
}), sr = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (n) => {
      var i, u, f, d, y;
      const o = ((f = (u = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : u.values) == null ? void 0 : f[n]) || Tt[n];
      return o ? ((y = (d = e.theme) == null ? void 0 : d.breakpoints) == null ? void 0 : y.unit) !== "px" ? {
        maxWidth: `${o}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: o
      } : {
        maxWidth: _e(n)
      };
    };
    return $e(e, e.maxWidth, r);
  }
  return null;
};
sr.filterProps = ["maxWidth"];
const Wi = fe({
  prop: "minWidth",
  transform: _e
}), Ui = fe({
  prop: "height",
  transform: _e
}), Yi = fe({
  prop: "maxHeight",
  transform: _e
}), zi = fe({
  prop: "minHeight",
  transform: _e
});
fe({
  prop: "size",
  cssProperty: "width",
  transform: _e
});
fe({
  prop: "size",
  cssProperty: "height",
  transform: _e
});
const qi = fe({
  prop: "boxSizing"
});
Ot(Vi, sr, Wi, Ui, Yi, zi, qi);
const It = {
  // borders
  border: {
    themeKey: "borders",
    transform: Re
  },
  borderTop: {
    themeKey: "borders",
    transform: Re
  },
  borderRight: {
    themeKey: "borders",
    transform: Re
  },
  borderBottom: {
    themeKey: "borders",
    transform: Re
  },
  borderLeft: {
    themeKey: "borders",
    transform: Re
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Re
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: kt
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ge
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ge
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ge
  },
  // spacing
  p: {
    style: ce
  },
  pt: {
    style: ce
  },
  pr: {
    style: ce
  },
  pb: {
    style: ce
  },
  pl: {
    style: ce
  },
  px: {
    style: ce
  },
  py: {
    style: ce
  },
  padding: {
    style: ce
  },
  paddingTop: {
    style: ce
  },
  paddingRight: {
    style: ce
  },
  paddingBottom: {
    style: ce
  },
  paddingLeft: {
    style: ce
  },
  paddingX: {
    style: ce
  },
  paddingY: {
    style: ce
  },
  paddingInline: {
    style: ce
  },
  paddingInlineStart: {
    style: ce
  },
  paddingInlineEnd: {
    style: ce
  },
  paddingBlock: {
    style: ce
  },
  paddingBlockStart: {
    style: ce
  },
  paddingBlockEnd: {
    style: ce
  },
  m: {
    style: ue
  },
  mt: {
    style: ue
  },
  mr: {
    style: ue
  },
  mb: {
    style: ue
  },
  ml: {
    style: ue
  },
  mx: {
    style: ue
  },
  my: {
    style: ue
  },
  margin: {
    style: ue
  },
  marginTop: {
    style: ue
  },
  marginRight: {
    style: ue
  },
  marginBottom: {
    style: ue
  },
  marginLeft: {
    style: ue
  },
  marginX: {
    style: ue
  },
  marginY: {
    style: ue
  },
  marginInline: {
    style: ue
  },
  marginInlineStart: {
    style: ue
  },
  marginInlineEnd: {
    style: ue
  },
  marginBlock: {
    style: ue
  },
  marginBlockStart: {
    style: ue
  },
  marginBlockEnd: {
    style: ue
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: $t
  },
  rowGap: {
    style: Pt
  },
  columnGap: {
    style: At
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: _e
  },
  maxWidth: {
    style: sr
  },
  minWidth: {
    transform: _e
  },
  height: {
    transform: _e
  },
  maxHeight: {
    transform: _e
  },
  minHeight: {
    transform: _e
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Gi(...e) {
  const r = e.reduce((o, i) => o.concat(Object.keys(i)), []), n = new Set(r);
  return e.every((o) => n.size === Object.keys(o).length);
}
function Ki(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Hi() {
  function e(n, o, i, u) {
    const f = {
      [n]: o,
      theme: i
    }, d = u[n];
    if (!d)
      return {
        [n]: o
      };
    const {
      cssProperty: y = n,
      themeKey: b,
      transform: _,
      style: v
    } = d;
    if (o == null)
      return null;
    if (b === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const E = wt(i, b) || {};
    return v ? v(f) : $e(f, o, (w) => {
      let l = _t(E, _, w);
      return w === l && typeof w == "string" && (l = _t(E, _, `${n}${w === "default" ? "" : On(w)}`, w)), y === !1 ? l : {
        [y]: l
      };
    });
  }
  function r(n) {
    const {
      sx: o,
      theme: i = {}
    } = n || {};
    if (!o)
      return null;
    const u = i.unstable_sxConfig ?? It;
    function f(d) {
      let y = d;
      if (typeof d == "function")
        y = d(i);
      else if (typeof d != "object")
        return d;
      if (!y)
        return null;
      const b = ui(i.breakpoints), _ = Object.keys(b);
      let v = b;
      return Object.keys(y).forEach((E) => {
        const x = Ki(y[E], i);
        if (x != null)
          if (typeof x == "object")
            if (u[E])
              v = rt(v, e(E, x, i, u));
            else {
              const w = $e({
                theme: i
              }, x, (l) => ({
                [E]: l
              }));
              Gi(w, x) ? v[E] = r({
                sx: x,
                theme: i
              }) : v = rt(v, w);
            }
          else
            v = rt(v, e(E, x, i, u));
      }), ri(i, ci(_, v));
    }
    return Array.isArray(o) ? o.map(f) : f(o);
  }
  return r;
}
const Mt = Hi();
Mt.filterProps = ["sx"];
function Zi(e, r) {
  var o;
  const n = this;
  if (n.vars) {
    if (!((o = n.colorSchemes) != null && o[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? r : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: r
    });
  }
  return n.palette.mode === e ? r : {};
}
function Xi(e = {}, ...r) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: i,
    shape: u = {},
    ...f
  } = e, d = ti(n), y = $n(i);
  let b = Te({
    breakpoints: d,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...o
    },
    spacing: y,
    shape: {
      ...ai,
      ...u
    }
  }, f);
  return b = ii(b), b.applyStyles = Zi, b = r.reduce((_, v) => Te(_, v), b), b.unstable_sxConfig = {
    ...It,
    ...f == null ? void 0 : f.unstable_sxConfig
  }, b.unstable_sx = function(v) {
    return Mt({
      sx: v,
      theme: this
    });
  }, b;
}
const mn = (e) => e, Qi = () => {
  let e = mn;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = mn;
    }
  };
}, Ji = Qi(), ea = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ta(e, r, n = "Mui") {
  const o = ea[r];
  return o ? `${n}-${o}` : `${Ji.generate(e)}-${r}`;
}
function ra(e, r = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, n));
}
function ur(e, r = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < r || e > n) && console.error(`MUI: The value provided ${e} is out of range [${r}, ${n}].`), ra(e, r, n);
}
function na(e) {
  e = e.slice(1);
  const r = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(r);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, i) => i < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function De(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return De(na(e));
  const r = e.indexOf("("), n = e.substring(0, r);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Me(9, e));
  let o = e.substring(r + 1, e.length - 1), i;
  if (n === "color") {
    if (o = o.split(" "), i = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Me(10, i));
  } else
    o = o.split(",");
  return o = o.map((u) => parseFloat(u)), {
    type: n,
    values: o,
    colorSpace: i
  };
}
const oa = (e) => {
  const r = De(e);
  return r.values.slice(0, 3).map((n, o) => r.type.includes("hsl") && o !== 0 ? `${n}%` : n).join(" ");
}, et = (e, r) => {
  try {
    return oa(e);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
};
function Dt(e) {
  const {
    type: r,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return r.includes("rgb") ? o = o.map((i, u) => u < 3 ? parseInt(i, 10) : i) : r.includes("hsl") && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), r.includes("color") ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${r}(${o})`;
}
function An(e) {
  e = De(e);
  const {
    values: r
  } = e, n = r[0], o = r[1] / 100, i = r[2] / 100, u = o * Math.min(i, 1 - i), f = (b, _ = (b + n / 30) % 12) => i - u * Math.max(Math.min(_ - 3, 9 - _, 1), -1);
  let d = "rgb";
  const y = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  return e.type === "hsla" && (d += "a", y.push(r[3])), Dt({
    type: d,
    values: y
  });
}
function rr(e) {
  e = De(e);
  let r = e.type === "hsl" || e.type === "hsla" ? De(An(e)).values : e.values;
  return r = r.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function hn(e, r) {
  const n = rr(e), o = rr(r);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
function ia(e, r) {
  return e = De(e), r = ur(r), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${r}` : e.values[3] = r, Dt(e);
}
function St(e, r, n) {
  try {
    return ia(e, r);
  } catch {
    return e;
  }
}
function cr(e, r) {
  if (e = De(e), r = ur(r), e.type.includes("hsl"))
    e.values[2] *= 1 - r;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - r;
  return Dt(e);
}
function te(e, r, n) {
  try {
    return cr(e, r);
  } catch {
    return e;
  }
}
function lr(e, r) {
  if (e = De(e), r = ur(r), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * r;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * r;
  return Dt(e);
}
function re(e, r, n) {
  try {
    return lr(e, r);
  } catch {
    return e;
  }
}
function aa(e, r = 0.15) {
  return rr(e) > 0.5 ? cr(e, r) : lr(e, r);
}
function Ct(e, r, n) {
  try {
    return aa(e, r);
  } catch {
    return e;
  }
}
function sa(e = "") {
  function r(...o) {
    if (!o.length)
      return "";
    const i = o[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${r(...o.slice(1))})` : `, ${i}`;
  }
  return (o, ...i) => `var(--${e ? `${e}-` : ""}${o}${r(...i)})`;
}
const gn = (e, r, n, o = []) => {
  let i = e;
  r.forEach((u, f) => {
    f === r.length - 1 ? Array.isArray(i) ? i[Number(u)] = n : i && typeof i == "object" && (i[u] = n) : i && typeof i == "object" && (i[u] || (i[u] = o.includes(u) ? [] : {}), i = i[u]);
  });
}, ua = (e, r, n) => {
  function o(i, u = [], f = []) {
    Object.entries(i).forEach(([d, y]) => {
      (!n || n && !n([...u, d])) && y != null && (typeof y == "object" && Object.keys(y).length > 0 ? o(y, [...u, d], Array.isArray(y) ? [...f, d] : f) : r([...u, d], y, f));
    });
  }
  o(e);
}, ca = (e, r) => typeof r == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((o) => e.includes(o)) || e[e.length - 1].toLowerCase().includes("opacity") ? r : `${r}px` : r;
function er(e, r) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: o
  } = r || {}, i = {}, u = {}, f = {};
  return ua(
    e,
    (d, y, b) => {
      if ((typeof y == "string" || typeof y == "number") && (!o || !o(d, y))) {
        const _ = `--${n ? `${n}-` : ""}${d.join("-")}`, v = ca(d, y);
        Object.assign(i, {
          [_]: v
        }), gn(u, d, `var(${_})`, b), gn(f, d, `var(${_}, ${v})`, b);
      }
    },
    (d) => d[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: u,
    varsWithDefaults: f
  };
}
function la(e, r = {}) {
  const {
    getSelector: n = I,
    disableCssColorScheme: o,
    colorSchemeSelector: i
  } = r, {
    colorSchemes: u = {},
    components: f,
    defaultColorScheme: d = "light",
    ...y
  } = e, {
    vars: b,
    css: _,
    varsWithDefaults: v
  } = er(y, r);
  let E = v;
  const x = {}, {
    [d]: w,
    ...l
  } = u;
  if (Object.entries(l || {}).forEach(([L, $]) => {
    const {
      vars: S,
      css: K,
      varsWithDefaults: le
    } = er($, r);
    E = Te(E, le), x[L] = {
      css: K,
      vars: S
    };
  }), w) {
    const {
      css: L,
      vars: $,
      varsWithDefaults: S
    } = er(w, r);
    E = Te(E, S), x[d] = {
      css: L,
      vars: $
    };
  }
  function I(L, $) {
    var K, le;
    let S = i;
    if (i === "class" && (S = ".%s"), i === "data" && (S = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (S = `[${i}="%s"]`), L) {
      if (S === "media")
        return e.defaultColorScheme === L ? ":root" : {
          [`@media (prefers-color-scheme: ${((le = (K = u[L]) == null ? void 0 : K.palette) == null ? void 0 : le.mode) || L})`]: {
            ":root": $
          }
        };
      if (S)
        return e.defaultColorScheme === L ? `:root, ${S.replace("%s", String(L))}` : S.replace("%s", String(L));
    }
    return ":root";
  }
  return {
    vars: E,
    generateThemeVars: () => {
      let L = {
        ...b
      };
      return Object.entries(x).forEach(([, {
        vars: $
      }]) => {
        L = Te(L, $);
      }), L;
    },
    generateStyleSheets: () => {
      var ve, he;
      const L = [], $ = e.defaultColorScheme || "light";
      function S(a, M) {
        Object.keys(M).length && L.push(typeof a == "string" ? {
          [a]: {
            ...M
          }
        } : a);
      }
      S(n(void 0, {
        ..._
      }), _);
      const {
        [$]: K,
        ...le
      } = x;
      if (K) {
        const {
          css: a
        } = K, M = (he = (ve = u[$]) == null ? void 0 : ve.palette) == null ? void 0 : he.mode, q = !o && M ? {
          colorScheme: M,
          ...a
        } : {
          ...a
        };
        S(n($, {
          ...q
        }), q);
      }
      return Object.entries(le).forEach(([a, {
        css: M
      }]) => {
        var ye, de;
        const q = (de = (ye = u[a]) == null ? void 0 : ye.palette) == null ? void 0 : de.mode, X = !o && q ? {
          colorScheme: q,
          ...M
        } : {
          ...M
        };
        S(n(a, {
          ...X
        }), X);
      }), L;
    }
  };
}
function fa(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const nt = {
  black: "#000",
  white: "#fff"
}, da = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Ve = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, We = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Qe = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Ue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Ye = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, ze = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function Pn() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: nt.white,
      default: nt.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const pa = Pn();
function In() {
  return {
    text: {
      primary: nt.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: nt.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const yn = In();
function vn(e, r, n, o) {
  const i = o.light || o, u = o.dark || o * 1.5;
  e[r] || (e.hasOwnProperty(n) ? e[r] = e[n] : r === "light" ? e.light = lr(e.main, i) : r === "dark" && (e.dark = cr(e.main, u)));
}
function ma(e = "light") {
  return e === "dark" ? {
    main: Ue[200],
    light: Ue[50],
    dark: Ue[400]
  } : {
    main: Ue[700],
    light: Ue[400],
    dark: Ue[800]
  };
}
function ha(e = "light") {
  return e === "dark" ? {
    main: Ve[200],
    light: Ve[50],
    dark: Ve[400]
  } : {
    main: Ve[500],
    light: Ve[300],
    dark: Ve[700]
  };
}
function ga(e = "light") {
  return e === "dark" ? {
    main: We[500],
    light: We[300],
    dark: We[700]
  } : {
    main: We[700],
    light: We[400],
    dark: We[800]
  };
}
function ya(e = "light") {
  return e === "dark" ? {
    main: Ye[400],
    light: Ye[300],
    dark: Ye[700]
  } : {
    main: Ye[700],
    light: Ye[500],
    dark: Ye[900]
  };
}
function va(e = "light") {
  return e === "dark" ? {
    main: ze[400],
    light: ze[300],
    dark: ze[700]
  } : {
    main: ze[800],
    light: ze[500],
    dark: ze[900]
  };
}
function ba(e = "light") {
  return e === "dark" ? {
    main: Qe[400],
    light: Qe[300],
    dark: Qe[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Qe[500],
    dark: Qe[900]
  };
}
function fr(e) {
  const {
    mode: r = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2,
    ...i
  } = e, u = e.primary || ma(r), f = e.secondary || ha(r), d = e.error || ga(r), y = e.info || ya(r), b = e.success || va(r), _ = e.warning || ba(r);
  function v(l) {
    const I = hn(l, yn.text.primary) >= n ? yn.text.primary : pa.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const Y = hn(l, I);
      Y < 3 && console.error([`MUI: The contrast ratio of ${Y}:1 for ${I} on ${l}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return I;
  }
  const E = ({
    color: l,
    name: I,
    mainShade: Y = 500,
    lightShade: ne = 300,
    darkShade: L = 700
  }) => {
    if (l = {
      ...l
    }, !l.main && l[Y] && (l.main = l[Y]), !l.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${I ? ` (${I})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${Y}\` property.` : Me(11, I ? ` (${I})` : "", Y));
    if (typeof l.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${I ? ` (${I})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(l.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Me(12, I ? ` (${I})` : "", JSON.stringify(l.main)));
    return vn(l, "light", ne, o), vn(l, "dark", L, o), l.contrastText || (l.contrastText = v(l.main)), l;
  };
  let x;
  return r === "light" ? x = Pn() : r === "dark" && (x = In()), process.env.NODE_ENV !== "production" && (x || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), Te({
    // A collection of common colors.
    common: {
      ...nt
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: E({
      color: u,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: E({
      color: f,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: E({
      color: d,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: E({
      color: _,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: E({
      color: y,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: E({
      color: b,
      name: "success"
    }),
    // The grey colors.
    grey: da,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: v,
    // Generate a rich color object.
    augmentColor: E,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o,
    // The light and dark mode object.
    ...x
  }, i);
}
function Ea(e) {
  const r = {};
  return Object.entries(e).forEach((o) => {
    const [i, u] = o;
    typeof u == "object" && (r[i] = `${u.fontStyle ? `${u.fontStyle} ` : ""}${u.fontVariant ? `${u.fontVariant} ` : ""}${u.fontWeight ? `${u.fontWeight} ` : ""}${u.fontStretch ? `${u.fontStretch} ` : ""}${u.fontSize || ""}${u.lineHeight ? `/${u.lineHeight} ` : ""}${u.fontFamily || ""}`);
  }), r;
}
function Sa(e, r) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...r
  };
}
function Ca(e) {
  return Math.round(e * 1e5) / 1e5;
}
const bn = {
  textTransform: "uppercase"
}, En = '"Roboto", "Helvetica", "Arial", sans-serif';
function _a(e, r) {
  const {
    fontFamily: n = En,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: u = 400,
    fontWeightMedium: f = 500,
    fontWeightBold: d = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: y = 16,
    // Apply the CSS properties to all the variants.
    allVariants: b,
    pxToRem: _,
    ...v
  } = typeof r == "function" ? r(e) : r;
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof y != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const E = o / 14, x = _ || ((I) => `${I / y * E}rem`), w = (I, Y, ne, L, $) => ({
    fontFamily: n,
    fontWeight: I,
    fontSize: x(Y),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: ne,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === En ? {
      letterSpacing: `${Ca(L / Y)}em`
    } : {},
    ...$,
    ...b
  }), l = {
    h1: w(i, 96, 1.167, -1.5),
    h2: w(i, 60, 1.2, -0.5),
    h3: w(u, 48, 1.167, 0),
    h4: w(u, 34, 1.235, 0.25),
    h5: w(u, 24, 1.334, 0),
    h6: w(f, 20, 1.6, 0.15),
    subtitle1: w(u, 16, 1.75, 0.15),
    subtitle2: w(f, 14, 1.57, 0.1),
    body1: w(u, 16, 1.5, 0.15),
    body2: w(u, 14, 1.43, 0.15),
    button: w(f, 14, 1.75, 0.4, bn),
    caption: w(u, 12, 1.66, 0.4),
    overline: w(u, 12, 2.66, 1, bn),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Te({
    htmlFontSize: y,
    pxToRem: x,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: u,
    fontWeightMedium: f,
    fontWeightBold: d,
    ...l
  }, v, {
    clone: !1
    // No need to clone deep
  });
}
const Ta = 0.2, wa = 0.14, Ra = 0.12;
function ae(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Ta})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${wa})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Ra})`].join(",");
}
const xa = ["none", ae(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ae(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ae(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ae(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ae(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ae(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ae(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ae(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ae(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ae(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ae(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ae(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ae(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ae(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ae(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ae(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ae(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ae(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ae(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ae(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ae(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ae(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ae(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ae(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Oa = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, ka = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Sn(e) {
  return `${Math.round(e)}ms`;
}
function $a(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.min(Math.round((4 + 15 * r ** 0.25 + r / 5) * 10), 3e3);
}
function Aa(e) {
  const r = {
    ...Oa,
    ...e.easing
  }, n = {
    ...ka,
    ...e.duration
  };
  return {
    getAutoHeightDuration: $a,
    create: (i = ["all"], u = {}) => {
      const {
        duration: f = n.standard,
        easing: d = r.easeInOut,
        delay: y = 0,
        ...b
      } = u;
      if (process.env.NODE_ENV !== "production") {
        const _ = (E) => typeof E == "string", v = (E) => !Number.isNaN(parseFloat(E));
        !_(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !v(f) && !_(f) && console.error(`MUI: Argument "duration" must be a number or a string but found ${f}.`), _(d) || console.error('MUI: Argument "easing" must be a string.'), !v(y) && !_(y) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof u != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(b).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(b).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((_) => `${_} ${typeof f == "string" ? f : Sn(f)} ${d} ${typeof y == "string" ? y : Sn(y)}`).join(",");
    },
    ...e,
    easing: r,
    duration: n
  };
}
const Pa = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Ia(e) {
  return Ie(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Mn(e = {}) {
  const r = {
    ...e
  };
  function n(o) {
    const i = Object.entries(o);
    for (let u = 0; u < i.length; u++) {
      const [f, d] = i[u];
      !Ia(d) || f.startsWith("unstable_") ? delete o[f] : Ie(d) && (o[f] = {
        ...d
      }, n(o[f]));
    }
  }
  return n(r), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(r, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function nr(e = {}, ...r) {
  const {
    breakpoints: n,
    mixins: o = {},
    spacing: i,
    palette: u = {},
    transitions: f = {},
    typography: d = {},
    shape: y,
    ...b
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : Me(20));
  const _ = fr(u), v = Xi(e);
  let E = Te(v, {
    mixins: Sa(v.breakpoints, o),
    palette: _,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: xa.slice(),
    typography: _a(_, d),
    transitions: Aa(f),
    zIndex: {
      ...Pa
    }
  });
  if (E = Te(E, b), E = r.reduce((x, w) => Te(x, w), E), process.env.NODE_ENV !== "production") {
    const x = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], w = (l, I) => {
      let Y;
      for (Y in l) {
        const ne = l[Y];
        if (x.includes(Y) && Object.keys(ne).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const L = ta("", Y);
            console.error([`MUI: The \`${I}\` component increases the CSS specificity of the \`${Y}\` internal state.`, "You can not override it like this: ", JSON.stringify(l, null, 2), "", `Instead, you need to use the '&.${L}' syntax:`, JSON.stringify({
              root: {
                [`&.${L}`]: ne
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          l[Y] = {};
        }
      }
    };
    Object.keys(E.components).forEach((l) => {
      const I = E.components[l].styleOverrides;
      I && l.startsWith("Mui") && w(I, l);
    });
  }
  return E.unstable_sxConfig = {
    ...It,
    ...b == null ? void 0 : b.unstable_sxConfig
  }, E.unstable_sx = function(w) {
    return Mt({
      sx: w,
      theme: this
    });
  }, E.toRuntimeSource = Mn, E;
}
function Ma(e) {
  let r;
  return e < 1 ? r = 5.11916 * e ** 2 : r = 4.5 * Math.log(e + 1) + 2, Math.round(r * 10) / 1e3;
}
const Da = [...Array(25)].map((e, r) => {
  if (r === 0)
    return "none";
  const n = Ma(r);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Dn(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Nn(e) {
  return e === "dark" ? Da : [];
}
function Na(e) {
  const {
    palette: r = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: o,
    ...i
  } = e, u = fr(r);
  return {
    palette: u,
    opacity: {
      ...Dn(u.mode),
      ...n
    },
    overlays: o || Nn(u.mode),
    ...i
  };
}
function ja(e) {
  var r;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((r = e[1]) != null && r.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Ba = (e) => [...[...Array(25)].map((r, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Fa = (e) => (r, n) => {
  const o = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let u = i;
  if (i === "class" && (u = ".%s"), i === "data" && (u = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (u = `[${i}="%s"]`), e.defaultColorScheme === r) {
    if (r === "dark") {
      const f = {};
      return Ba(e.cssVarPrefix).forEach((d) => {
        f[d] = n[d], delete n[d];
      }), u === "media" ? {
        [o]: n,
        "@media (prefers-color-scheme: dark)": {
          [o]: f
        }
      } : u ? {
        [u.replace("%s", r)]: f,
        [`${o}, ${u.replace("%s", r)}`]: n
      } : {
        [o]: {
          ...n,
          ...f
        }
      };
    }
    if (u && u !== "media")
      return `${o}, ${u.replace("%s", String(r))}`;
  } else if (r) {
    if (u === "media")
      return {
        [`@media (prefers-color-scheme: ${String(r)})`]: {
          [o]: n
        }
      };
    if (u)
      return u.replace("%s", String(r));
  }
  return o;
};
function La(e, r) {
  r.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function h(e, r, n) {
  !e[r] && n && (e[r] = n);
}
function tt(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : An(e);
}
function ke(e, r) {
  `${r}Channel` in e || (e[`${r}Channel`] = et(tt(e[r]), `MUI: Can't create \`palette.${r}Channel\` because \`palette.${r}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${r}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Va(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Oe = (e) => {
  try {
    return e();
  } catch {
  }
}, Wa = (e = "mui") => sa(e);
function tr(e, r, n, o) {
  if (!r)
    return;
  r = r === !0 ? {} : r;
  const i = o === "dark" ? "dark" : "light";
  if (!n) {
    e[o] = Na({
      ...r,
      palette: {
        mode: i,
        ...r == null ? void 0 : r.palette
      }
    });
    return;
  }
  const {
    palette: u,
    ...f
  } = nr({
    ...n,
    palette: {
      mode: i,
      ...r == null ? void 0 : r.palette
    }
  });
  return e[o] = {
    ...r,
    palette: u,
    opacity: {
      ...Dn(i),
      ...r == null ? void 0 : r.opacity
    },
    overlays: (r == null ? void 0 : r.overlays) || Nn(i)
  }, f;
}
function Ua(e = {}, ...r) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: o,
    disableCssColorScheme: i = !1,
    cssVarPrefix: u = "mui",
    shouldSkipGeneratingVar: f = ja,
    colorSchemeSelector: d = n.light && n.dark ? "media" : void 0,
    rootSelector: y = ":root",
    ...b
  } = e, _ = Object.keys(n)[0], v = o || (n.light && _ !== "light" ? "light" : _), E = Wa(u), {
    [v]: x,
    light: w,
    dark: l,
    ...I
  } = n, Y = {
    ...I
  };
  let ne = x;
  if ((v === "dark" && !("dark" in n) || v === "light" && !("light" in n)) && (ne = !0), !ne)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${v}\` option is either missing or invalid.` : Me(21, v));
  const L = tr(Y, ne, b, v);
  w && !Y.light && tr(Y, w, void 0, "light"), l && !Y.dark && tr(Y, l, void 0, "dark");
  let $ = {
    defaultColorScheme: v,
    ...L,
    cssVarPrefix: u,
    colorSchemeSelector: d,
    rootSelector: y,
    getCssVar: E,
    colorSchemes: Y,
    font: {
      ...Ea(L.typography),
      ...L.font
    },
    spacing: Va(b.spacing)
  };
  Object.keys($.colorSchemes).forEach((he) => {
    const a = $.colorSchemes[he].palette, M = (q) => {
      const X = q.split("-"), ye = X[1], de = X[2];
      return E(q, a[ye][de]);
    };
    if (a.mode === "light" && (h(a.common, "background", "#fff"), h(a.common, "onBackground", "#000")), a.mode === "dark" && (h(a.common, "background", "#000"), h(a.common, "onBackground", "#fff")), La(a, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), a.mode === "light") {
      h(a.Alert, "errorColor", te(a.error.light, 0.6)), h(a.Alert, "infoColor", te(a.info.light, 0.6)), h(a.Alert, "successColor", te(a.success.light, 0.6)), h(a.Alert, "warningColor", te(a.warning.light, 0.6)), h(a.Alert, "errorFilledBg", M("palette-error-main")), h(a.Alert, "infoFilledBg", M("palette-info-main")), h(a.Alert, "successFilledBg", M("palette-success-main")), h(a.Alert, "warningFilledBg", M("palette-warning-main")), h(a.Alert, "errorFilledColor", Oe(() => a.getContrastText(a.error.main))), h(a.Alert, "infoFilledColor", Oe(() => a.getContrastText(a.info.main))), h(a.Alert, "successFilledColor", Oe(() => a.getContrastText(a.success.main))), h(a.Alert, "warningFilledColor", Oe(() => a.getContrastText(a.warning.main))), h(a.Alert, "errorStandardBg", re(a.error.light, 0.9)), h(a.Alert, "infoStandardBg", re(a.info.light, 0.9)), h(a.Alert, "successStandardBg", re(a.success.light, 0.9)), h(a.Alert, "warningStandardBg", re(a.warning.light, 0.9)), h(a.Alert, "errorIconColor", M("palette-error-main")), h(a.Alert, "infoIconColor", M("palette-info-main")), h(a.Alert, "successIconColor", M("palette-success-main")), h(a.Alert, "warningIconColor", M("palette-warning-main")), h(a.AppBar, "defaultBg", M("palette-grey-100")), h(a.Avatar, "defaultBg", M("palette-grey-400")), h(a.Button, "inheritContainedBg", M("palette-grey-300")), h(a.Button, "inheritContainedHoverBg", M("palette-grey-A100")), h(a.Chip, "defaultBorder", M("palette-grey-400")), h(a.Chip, "defaultAvatarColor", M("palette-grey-700")), h(a.Chip, "defaultIconColor", M("palette-grey-700")), h(a.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), h(a.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), h(a.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), h(a.LinearProgress, "primaryBg", re(a.primary.main, 0.62)), h(a.LinearProgress, "secondaryBg", re(a.secondary.main, 0.62)), h(a.LinearProgress, "errorBg", re(a.error.main, 0.62)), h(a.LinearProgress, "infoBg", re(a.info.main, 0.62)), h(a.LinearProgress, "successBg", re(a.success.main, 0.62)), h(a.LinearProgress, "warningBg", re(a.warning.main, 0.62)), h(a.Skeleton, "bg", `rgba(${M("palette-text-primaryChannel")} / 0.11)`), h(a.Slider, "primaryTrack", re(a.primary.main, 0.62)), h(a.Slider, "secondaryTrack", re(a.secondary.main, 0.62)), h(a.Slider, "errorTrack", re(a.error.main, 0.62)), h(a.Slider, "infoTrack", re(a.info.main, 0.62)), h(a.Slider, "successTrack", re(a.success.main, 0.62)), h(a.Slider, "warningTrack", re(a.warning.main, 0.62));
      const q = Ct(a.background.default, 0.8);
      h(a.SnackbarContent, "bg", q), h(a.SnackbarContent, "color", Oe(() => a.getContrastText(q))), h(a.SpeedDialAction, "fabHoverBg", Ct(a.background.paper, 0.15)), h(a.StepConnector, "border", M("palette-grey-400")), h(a.StepContent, "border", M("palette-grey-400")), h(a.Switch, "defaultColor", M("palette-common-white")), h(a.Switch, "defaultDisabledColor", M("palette-grey-100")), h(a.Switch, "primaryDisabledColor", re(a.primary.main, 0.62)), h(a.Switch, "secondaryDisabledColor", re(a.secondary.main, 0.62)), h(a.Switch, "errorDisabledColor", re(a.error.main, 0.62)), h(a.Switch, "infoDisabledColor", re(a.info.main, 0.62)), h(a.Switch, "successDisabledColor", re(a.success.main, 0.62)), h(a.Switch, "warningDisabledColor", re(a.warning.main, 0.62)), h(a.TableCell, "border", re(St(a.divider, 1), 0.88)), h(a.Tooltip, "bg", St(a.grey[700], 0.92));
    }
    if (a.mode === "dark") {
      h(a.Alert, "errorColor", re(a.error.light, 0.6)), h(a.Alert, "infoColor", re(a.info.light, 0.6)), h(a.Alert, "successColor", re(a.success.light, 0.6)), h(a.Alert, "warningColor", re(a.warning.light, 0.6)), h(a.Alert, "errorFilledBg", M("palette-error-dark")), h(a.Alert, "infoFilledBg", M("palette-info-dark")), h(a.Alert, "successFilledBg", M("palette-success-dark")), h(a.Alert, "warningFilledBg", M("palette-warning-dark")), h(a.Alert, "errorFilledColor", Oe(() => a.getContrastText(a.error.dark))), h(a.Alert, "infoFilledColor", Oe(() => a.getContrastText(a.info.dark))), h(a.Alert, "successFilledColor", Oe(() => a.getContrastText(a.success.dark))), h(a.Alert, "warningFilledColor", Oe(() => a.getContrastText(a.warning.dark))), h(a.Alert, "errorStandardBg", te(a.error.light, 0.9)), h(a.Alert, "infoStandardBg", te(a.info.light, 0.9)), h(a.Alert, "successStandardBg", te(a.success.light, 0.9)), h(a.Alert, "warningStandardBg", te(a.warning.light, 0.9)), h(a.Alert, "errorIconColor", M("palette-error-main")), h(a.Alert, "infoIconColor", M("palette-info-main")), h(a.Alert, "successIconColor", M("palette-success-main")), h(a.Alert, "warningIconColor", M("palette-warning-main")), h(a.AppBar, "defaultBg", M("palette-grey-900")), h(a.AppBar, "darkBg", M("palette-background-paper")), h(a.AppBar, "darkColor", M("palette-text-primary")), h(a.Avatar, "defaultBg", M("palette-grey-600")), h(a.Button, "inheritContainedBg", M("palette-grey-800")), h(a.Button, "inheritContainedHoverBg", M("palette-grey-700")), h(a.Chip, "defaultBorder", M("palette-grey-700")), h(a.Chip, "defaultAvatarColor", M("palette-grey-300")), h(a.Chip, "defaultIconColor", M("palette-grey-300")), h(a.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), h(a.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), h(a.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), h(a.LinearProgress, "primaryBg", te(a.primary.main, 0.5)), h(a.LinearProgress, "secondaryBg", te(a.secondary.main, 0.5)), h(a.LinearProgress, "errorBg", te(a.error.main, 0.5)), h(a.LinearProgress, "infoBg", te(a.info.main, 0.5)), h(a.LinearProgress, "successBg", te(a.success.main, 0.5)), h(a.LinearProgress, "warningBg", te(a.warning.main, 0.5)), h(a.Skeleton, "bg", `rgba(${M("palette-text-primaryChannel")} / 0.13)`), h(a.Slider, "primaryTrack", te(a.primary.main, 0.5)), h(a.Slider, "secondaryTrack", te(a.secondary.main, 0.5)), h(a.Slider, "errorTrack", te(a.error.main, 0.5)), h(a.Slider, "infoTrack", te(a.info.main, 0.5)), h(a.Slider, "successTrack", te(a.success.main, 0.5)), h(a.Slider, "warningTrack", te(a.warning.main, 0.5));
      const q = Ct(a.background.default, 0.98);
      h(a.SnackbarContent, "bg", q), h(a.SnackbarContent, "color", Oe(() => a.getContrastText(q))), h(a.SpeedDialAction, "fabHoverBg", Ct(a.background.paper, 0.15)), h(a.StepConnector, "border", M("palette-grey-600")), h(a.StepContent, "border", M("palette-grey-600")), h(a.Switch, "defaultColor", M("palette-grey-300")), h(a.Switch, "defaultDisabledColor", M("palette-grey-600")), h(a.Switch, "primaryDisabledColor", te(a.primary.main, 0.55)), h(a.Switch, "secondaryDisabledColor", te(a.secondary.main, 0.55)), h(a.Switch, "errorDisabledColor", te(a.error.main, 0.55)), h(a.Switch, "infoDisabledColor", te(a.info.main, 0.55)), h(a.Switch, "successDisabledColor", te(a.success.main, 0.55)), h(a.Switch, "warningDisabledColor", te(a.warning.main, 0.55)), h(a.TableCell, "border", te(St(a.divider, 1), 0.68)), h(a.Tooltip, "bg", St(a.grey[700], 0.92));
    }
    ke(a.background, "default"), ke(a.background, "paper"), ke(a.common, "background"), ke(a.common, "onBackground"), ke(a, "divider"), Object.keys(a).forEach((q) => {
      const X = a[q];
      q !== "tonalOffset" && X && typeof X == "object" && (X.main && h(a[q], "mainChannel", et(tt(X.main))), X.light && h(a[q], "lightChannel", et(tt(X.light))), X.dark && h(a[q], "darkChannel", et(tt(X.dark))), X.contrastText && h(a[q], "contrastTextChannel", et(tt(X.contrastText))), q === "text" && (ke(a[q], "primary"), ke(a[q], "secondary")), q === "action" && (X.active && ke(a[q], "active"), X.selected && ke(a[q], "selected")));
    });
  }), $ = r.reduce((he, a) => Te(he, a), $);
  const S = {
    prefix: u,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: f,
    getSelector: Fa($)
  }, {
    vars: K,
    generateThemeVars: le,
    generateStyleSheets: ve
  } = la($, S);
  return $.vars = K, Object.entries($.colorSchemes[$.defaultColorScheme]).forEach(([he, a]) => {
    $[he] = a;
  }), $.generateThemeVars = le, $.generateStyleSheets = ve, $.generateSpacing = function() {
    return $n(b.spacing, ar(this));
  }, $.getColorSchemeSelector = fa(d), $.spacing = $.generateSpacing(), $.shouldSkipGeneratingVar = f, $.unstable_sxConfig = {
    ...It,
    ...b == null ? void 0 : b.unstable_sxConfig
  }, $.unstable_sx = function(a) {
    return Mt({
      sx: a,
      theme: this
    });
  }, $.toRuntimeSource = Mn, $;
}
function Cn(e, r, n) {
  e.colorSchemes && n && (e.colorSchemes[r] = {
    ...n !== !0 && n,
    palette: fr({
      ...n === !0 ? {} : n.palette,
      mode: r
    })
    // cast type to skip module augmentation test
  });
}
function Ya(e = {}, ...r) {
  const {
    palette: n,
    cssVariables: o = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: u = n == null ? void 0 : n.mode,
    ...f
  } = e, d = u || "light", y = i == null ? void 0 : i[d], b = {
    ...i,
    ...n ? {
      [d]: {
        ...typeof y != "boolean" && y,
        palette: n
      }
    } : void 0
  };
  if (o === !1) {
    if (!("colorSchemes" in e))
      return nr(e, ...r);
    let _ = n;
    "palette" in e || b[d] && (b[d] !== !0 ? _ = b[d].palette : d === "dark" && (_ = {
      mode: "dark"
    }));
    const v = nr({
      ...e,
      palette: _
    }, ...r);
    return v.defaultColorScheme = d, v.colorSchemes = b, v.palette.mode === "light" && (v.colorSchemes.light = {
      ...b.light !== !0 && b.light,
      palette: v.palette
    }, Cn(v, "dark", b.dark)), v.palette.mode === "dark" && (v.colorSchemes.dark = {
      ...b.dark !== !0 && b.dark,
      palette: v.palette
    }, Cn(v, "light", b.light)), v;
  }
  return !n && !("light" in b) && d === "light" && (b.light = !0), Ua({
    ...f,
    colorSchemes: b,
    defaultColorScheme: d,
    ...typeof o != "boolean" && o
  }, ...r);
}
const qe = {
  foxOrange: "#f8991d",
  darkRed: "#340f15",
  darkGreen: "#3E6617",
  darkGrey: "#363636"
};
function qa() {
  return Ya({
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: qe.darkGrey
          }
        },
        components: {
          MuiAppBar: {
            styleOverrides: {
              colorPrimary: {
                backgroundColor: qe.darkGrey,
                color: "#fff"
              }
            }
          }
        }
      },
      dark: {
        palette: {
          primary: {
            main: qe.darkGrey
          }
        },
        components: {
          MuiAppBar: {
            styleOverrides: {
              colorPrimary: {
                backgroundColor: qe.darkGrey,
                color: "#fff"
              }
            }
          }
        }
      }
    },
    // Switch: primary.main is brand darkGrey (#363636), which renders a
    // near-black thumb/track when ON — invisible on a dark background. Force
    // the checked state to the brand accent (foxOrange) in both schemes so ON
    // is clearly distinguishable from OFF and legible in light + dark.
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            "&.Mui-checked": {
              color: qe.foxOrange
            },
            "&.Mui-checked + .MuiSwitch-track": {
              backgroundColor: qe.foxOrange
            }
          }
        }
      }
    }
  });
}
function Ga(e) {
  return `<!doctype html>
  <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
  
  <head>
      <meta charset="utf-8" />
      <meta content="width=device-width" name="viewport" />
      <meta content="IE=edge" http-equiv="X-UA-Compatible" />
      <meta name="x-apple-disable-message-reformatting" />
      <meta content="telephone=no,address=no,email=no,date=no,url=no" name="format-detection" />
      <title>Fox Village Online Entry System</title>
      <link href="https://fonts.googleapis.com/css?family=Inter:400" rel="stylesheet" type="text/css">
      <link href="https://fonts.googleapis.com/css?family=Inter:500" rel="stylesheet" type="text/css">
      <!--[if mso]>
              <style>
                  * {
                      font-family: sans-serif !important;
                  }
              </style>
          <![endif]-->
      <!--[if !mso]><!-->
      <!-- <![endif]-->
      <style>
          html {
              margin: 0 !important;
              padding: 0 !important;
          }
  
          .greybox{
              margin: 4px 0px;
              padding: 4px;
              text-align: center;
              background-color: lightgray;
              color: #000000;
          }
  
          .red-text{
              color: darkred;
          }
  
          * {
              -ms-text-size-adjust: 100%;
              -webkit-text-size-adjust: 100%;
          }
  
          td {
              vertical-align: top;
              mso-table-lspace: 0pt !important;
              mso-table-rspace: 0pt !important;
          }
  
          a {
              text-decoration: none;
          }
  
          img {
              -ms-interpolation-mode: bicubic;
          }
  
          @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
              u~div .email-container {
                  min-width: 320px !important;
              }
          }
  
          @media only screen and (min-device-width: 375px) and (max-device-width: 413px) {
              u~div .email-container {
                  min-width: 375px !important;
              }
          }
  
          @media only screen and (min-device-width: 414px) {
              u~div .email-container {
                  min-width: 414px !important;
              }
          }
      </style>
      <!--[if gte mso 9]>
          <xml>
              <o:OfficeDocumentSettings>
                  <o:AllowPNG/>
                  <o:PixelsPerInch>96</o:PixelsPerInch>
              </o:OfficeDocumentSettings>
          </xml>
          <![endif]-->
      <style>
          @media only screen and (max-device-width: 599px),
          only screen and (max-width: 599px) {
  
              .eh {
                  height: auto !important;
              }
  
              .desktop {
                  display: none !important;
                  height: 0 !important;
                  margin: 0 !important;
                  max-height: 0 !important;
                  overflow: hidden !important;
                  padding: 0 !important;
                  visibility: hidden !important;
                  width: 0 !important;
              }
  
              .mobile {
                  display: block !important;
                  width: auto !important;
                  height: auto !important;
                  float: none !important;
              }
  
              .email-container {
                  width: 100% !important;
                  margin: auto !important;
              }
  
              .stack-column,
              .stack-column-center {
                  display: block !important;
                  width: 100% !important;
                  max-width: 100% !important;
                  direction: ltr !important;
              }
  
              .wid-auto {
                  width: auto !important;
              }
  
              .table-w-full-mobile {
                  width: 100%;
              }
  
  
  
  
              .mobile-center {
                  text-align: center;
              }
  
              .mobile-center>table {
                  display: inline-block;
                  vertical-align: inherit;
              }
  
              .mobile-left {
                  text-align: left;
              }
  
              .mobile-left>table {
                  display: inline-block;
                  vertical-align: inherit;
              }
  
              .mobile-right {
                  text-align: right;
              }
  
              .mobile-right>table {
                  display: inline-block;
                  vertical-align: inherit;
              }
  
          }
      </style>
  </head>
  
  <body width="100%" style="margin:0;padding:0!important;mso-line-height-rule:exactly;">
      <div>
          <!--[if gte mso 9]>
                  <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                  <v:fill type="tile" color="#1e1e1e"/>
                  </v:background>
                  <![endif]-->
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
              <tr>
                  <td valign="top" align="center">
                      <table bgcolor="#ffffff" style="margin:0 auto;" align="center" id="brick_container" cellspacing="0"
                          cellpadding="0" border="0" width="600" class="email-container">
                          <tr>
                              <td width="600">
                                  <table cellspacing="0" cellpadding="0" border="0">
                                      <tr>
                                          <td width="600" style="background-color:#ffffff;  " bgcolor="#ffffff">
                                              <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                                  <tr>
                                                      <td>
                                                          <table cellspacing="0" cellpadding="0" border="0">
                                                              <tr>
                                                                  <td style="height:272px; background-color:#ffffff;  "
                                                                      bgcolor="#ffffff">
                                                                      <table width="100%" border="0" cellpadding="0"
                                                                          cellspacing="0">
                                                                          <tr>
                                                                              <td width="100%">
                                                                                  <table width="100%" cellspacing="0"
                                                                                      cellpadding="0" border="0">
                                                                                      <tr>
                                                                                          <td width="100%"
                                                                                              style="vertical-align: middle; background-color:#f8991d;   padding-left:8px; padding-right:8px;"
                                                                                              bgcolor="#f8991d">
                                                                                              <table width="100%"
                                                                                                  border="0"
                                                                                                  cellpadding="0"
                                                                                                  cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td height="8"
                                                                                                          style="height:8px; min-height:8px; line-height:8px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td>
                                                                                                          <table
                                                                                                              cellspacing="0"
                                                                                                              cellpadding="0"
                                                                                                              border="0">
                                                                                                              <tr>
                                                                                                                  <td
                                                                                                                      style="vertical-align: middle;">
                                                                                                                      <table
                                                                                                                          cellspacing="0"
                                                                                                                          cellpadding="0"
                                                                                                                          border="0">
                                                                                                                          <tr>
                                                                                                                              <td align="center"
                                                                                                                                  style="vertical-align: middle;  ">
                                                                                                                                  <table
                                                                                                                                      width="100%"
                                                                                                                                      border="0"
                                                                                                                                      cellpadding="0"
                                                                                                                                      cellspacing="0">
                                                                                                                                      <tr>
                                                                                                                                          <td style="vertical-align: middle;"
                                                                                                                                              width="164"
                                                                                                                                              align="center">
                                                                                                                                              <img src="https://plugin.markaimg.com/public/7f27d7c6/Mn3xgdLRjDYU17MDTMjsfOs6veOmPe.png"
                                                                                                                                                  width="164"
                                                                                                                                                  border="0"
                                                                                                                                                  style="min-width:164px; width:164px;
                                                                                                                                                  height: auto; display: block;"
                                                                                                                                                  alt="Fox Village Online Entry System">
                                                                                                                                          </td>
                                                                                                                                      </tr>
                                                                                                                                  </table>
                                                                                                                              </td>
                                                                                                                          </tr>
                                                                                                                      </table>
                                                                                                                  </td>
                                                                                                              </tr>
                                                                                                          </table>
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td height="8"
                                                                                                          style="height:8px; min-height:8px; line-height:8px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                              </table>
                                                                                          </td>
                                                                                      </tr>
                                                                                  </table>
                                                                              </td>
                                                                          </tr>
                                                                          <tr>
                                                                              <td height="20"
                                                                                  style="height:20px; min-height:20px; line-height:20px;">
                                                                              </td>
                                                                          </tr>
                                                                          <tr>
                                                                              <td width="100%">
                                                                                  <table width="100%" cellspacing="0"
                                                                                      cellpadding="0" border="0">
                                                                                      <tr>
                                                                                          <td width="100%"
                                                                                              style="background-color:#ffffff;   padding-left:24px; padding-right:24px;"
                                                                                              bgcolor="#ffffff">
                                                                                              <table width="100%"
                                                                                                  border="0"
                                                                                                  cellpadding="0"
                                                                                                  cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td height="24"
                                                                                                          style="height:24px; min-height:24px; line-height:24px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td>
                                                                                                          <div
                                                                                                              style="line-height:24px;text-align:left;">
                                                                                                              <div
                                                                                                                  style="color:#667085;font-family:Inter,Arial,sans-serif;font-size:15px;line-height:24px;text-align:left;">
                                                                                                                  ${e}
  
                                                                                                          
  
                                                                                                              </div>
                                                                                                          </div>
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td height="24"
                                                                                                          style="height:24px; min-height:24px; line-height:24px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                              </table>
                                                                                          </td>
                                                                                      </tr>
                                                                                  </table>
                                                                              </td>
                                                                          </tr>
                                                                          <tr>
                                                                              <td height="20"
                                                                                  style="height:20px; min-height:20px; line-height:20px;">
                                                                              </td>
                                                                          </tr>
                                                                          <tr>
                                                                              <td width="600">
                                                                                  <table cellspacing="0" cellpadding="0"
                                                                                      border="0">
                                                                                      <tr>
                                                                                          <td width="584" align="center"
                                                                                              style="vertical-align: middle; height:99px; background-color:#f8991d;   padding-left:8px; padding-right:8px;"
                                                                                              bgcolor="#f8991d">
                                                                                              <table width="100%"
                                                                                                  border="0"
                                                                                                  cellpadding="0"
                                                                                                  cellspacing="0">
                                                                                                  <tr>
                                                                                                      <td height="8"
                                                                                                          style="height:8px; min-height:8px; line-height:8px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td align="center">
                                                                                                          <table
                                                                                                              cellspacing="0"
                                                                                                              cellpadding="0"
                                                                                                              border="0">
                                                                                                              <tr>
                                                                                                                  <td style="vertical-align: middle;"
                                                                                                                      align="center">
                                                                                                                      <div
                                                                                                                          style="line-height:12px;text-align:center;">
                                                                                                                          <span
                                                                                                                              style="color:#000000;font-weight:500;font-family:Inter,Arial,sans-serif;font-size:10px;line-height:14px;text-align:center;">Thank
                                                                                                                              you
                                                                                                                              for
                                                                                                                              using
                                                                                                                              the
                                                                                                                              Fox
                                                                                                                              Village
                                                                                                                              Online
                                                                                                                              Entry
                                                                                                                              Service.<br>We’d
                                                                                                                              love
                                                                                                                              your
                                                                                                                              feedback!
                                                                                                                              Email
                                                                                                                              us
                                                                                                                              at
                                                                                                                              <a style="color:#000000;text-decoration:none;"
                                                                                                                                  href="mailto:feedback@foxvillage.com"
                                                                                                                                  target="_blank">feedback@foxvillage.com</a>
                                                                                                                              <p><a
                                                                                                                                      href="https://foxvillage.com">Fox
                                                                                                                                      Village</a>
                                                                                                                                  |
                                                                                                                                  Made
                                                                                                                                  in
                                                                                                                                  the
                                                                                                                                  Pacific
                                                                                                                                  Northwest<br>🌲
                                                                                                                                  🇺🇸
                                                                                                                              </p>
                                                                                                                          </span>
                                                                                                                      </div>
                                                                                                                  </td>
                                                                                                              </tr>
                                                                                                          </table>
                                                                                                      </td>
                                                                                                  </tr>
                                                                                                  <tr>
                                                                                                      <td height="8"
                                                                                                          style="height:8px; min-height:8px; line-height:8px;">
                                                                                                      </td>
                                                                                                  </tr>
                                                                                              </table>
                                                                                          </td>
                                                                                      </tr>
                                                                                  </table>
                                                                              </td>
                                                                          </tr>
                                                                      </table>
                                                                  </td>
                                                              </tr>
                                                          </table>
                                                      </td>
                                                  </tr>
                                              </table>
                                          </td>
                                      </tr>
                                  </table>
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>
          </table>
      </div>
  </body>
  
  </html>`;
}
export {
  za as Logo,
  Ga as brandedEmailTemplate,
  qe as colors,
  qa as createBrandTheme
};
//# sourceMappingURL=brand.js.map
